export const NOT_REDUCER = 'NOT_REDUCER';
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';

export const LOAD_COURSES_SUCCESS = 'LOAD_COURSES_SUCCESS';
export const CREATE_COURSE_SUCCESS = 'CREATE_COURSE_SUCCESS';
export const UPDATE_COURSE_SUCCESS = 'UPDATE_COURSE_SUCCESS';
// NAVIGATION ACTIONS
export const UPDATE_USER_REGISTER_PROPERTY_STATE = 'UPDATE_USER_REGISTER_PROPERTY_STATE';
export const MERGE_USER_REGISTER_PROPERTY_STATE = 'MERGE_USER_REGISTER_PROPERTY_STATE';
export const CALC_USER_REGISTER_PROPERTY_STATE = 'CALC_USER_REGISTER_PROPERTY_STATE';
export const RESET_STATE_USER_REGISTER = 'RESET_STATE_USER_REGISTER';
/* #region CONVERSATION */
export const LOAD_CONVERSATIONS_REQUEST = 'LOAD_CONVERSATIONS_REQUEST';
export const LOAD_CONVERSATIONS_SUCCESS = 'LOAD_CONVERSATIONS_SUCCESS';
export const HIDDEN_STATEMENT_READ = 'HIDDEN_STATEMENT_READ';
export const HIDDEN_SAFETY_READ = 'HIDDEN_SAFETY_READ';
export const LOAD_NEW_CONVERSATIONS_SUCCESS = 'LOAD_NEW_CONVERSATIONS_SUCCESS';
export const UPDATE_DIFF_CONVERSATIONS_SUCCESS = 'UPDATE_DIFF_CONVERSATIONS_SUCCESS';
export const UPDATE_SERVER_TIME_GROUP_CHAT_SUCCESS = 'UPDATE_SERVER_TIME_GROUP_CHAT_SUCCESS';
export const LOAD_CONVERSATIONS_FAILURE = 'LOAD_CONVERSATIONS_FAILURE';
export const LOAD_MORE_CONVERSATIONS = 'LOAD_MORE_CONVERSATIONS';
export const RESET_CONVERSATIONS = 'RESET_CONVERSATIONS';
export const LOAD_MORE_CONVERSATIONS_FAILURE = 'LOAD_MORE_CONVERSATIONS_FAILURE';
export const PATCH_RULES_GROUP_CHAT_SUCCESS = 'PATCH_RULES_GROUP_CHAT_SUCCESS';
export const TOGGLE_AUTO_SELECT_CONVERSATION = 'TOGGLE_AUTO_SELECT_CONVERSATION';
export const UPDATE_USERS_ONLINE_STATUS = 'UPDATE_USERS_ONLINE_STATUS';

export const UPDATE_GROUP_CHAT_SHOULD_BE_SELECTED = 'UPDATE_GROUP_CHAT_SHOULD_BE_SELECTED';
export const REMOVE_ROOMJID_IN_JOINED_SUCCESS_ROOM_JIDS = 'REMOVE_ROOMJID_IN_JOINED_SUCCESS_ROOM_JIDS';
export const CLEAR_JOINED_SUCCESS_ROOM_JID = 'CLEAR_JOINED_SUCCESS_ROOM_JID';
export const UPDATE_JOINING_ROOM_JIDS = 'UPDATE_JOINING_ROOM_JIDS';
export const UPDATE_JOINED_ROOM_JIDS_FAILED = 'UPDATE_JOINED_ROOM_JIDS_FAILED';
export const UPDATE_ROOM_JID_BEING_JOINED = 'UPDATE_ROOM_JID_BEING_JOINED';
export const UPDATE_IS_ACTIVE_PRIVATE_ROOM_CONVERSATION = 'UPDATE_IS_ACTIVE_PRIVATE_ROOM_CONVERSATION';
export const UPDATE_JOINED_PRIVATE_GROUP_CHAT = 'UPDATE_JOINED_PRIVATE_GROUP_CHAT';
export const UPDATE_MESSAGE_ID_SELECTED = 'UPDATE_MESSAGE_ID_SELECTED';

export const ADD_DATA_TO_SCHEDULE_REMOVE_CONVERSATION = 'ADD_DATA_TO_SCHEDULE_REMOVE_CONVERSATION';
export const CLEAR_DATA_TO_SCHEDULE_REMOVE_CONVERSATION = 'CLEAR_DATA_TO_SCHEDULE_REMOVE_CONVERSATION';

export const SEARCH_CONVERSATIONS_SUCCESS = 'SEARCH_CONVERSATIONS_SUCCESS';
export const SELECT_PEERVCARD_SUCCESS = 'SELECT_PEERVCARD_SUCCESS';
export const SELECT_PEERVCARD_REQUEST = 'SELECT_PEERVCARD_REQUEST';
export const SELECT_PEERVCARD_FAILED = 'SELECT_PEERVCARD_FAILED';
export const PIN_CONVERSATION_SUCCESS = 'PIN_CONVERSATION_SUCCESS';
export const UNPIN_CONVERSATION_SUCCESS = 'UNPIN_CONVERSATION_SUCCESS';
export const DELETE_CONVERSATION_SUCCESS = 'DELETE_CONVERSATION_SUCCESS';
export const REPORT_CONVERSATION_SUCCESS = 'REPORT_CONVERSATION_SUCCESS';
export const UPDATE_LOAD_STATUS = 'UPDATE_LOAD_STATUS';
export const UPDATE_LASTTIME_SYNC = 'UPDATE_LASTTIME_SYNC';
export const RESET_PAGE_NUMBER_CONVERSATIONS = 'RESET_PAGE_NUMBER_CONVERSATIONS';
export const UPDATE_CONVERSATION = 'UPDATE_CONVERSATION';
export const UPDATE_MEMBER_COUNT = 'UPDATE_MEMBER_COUNT';
export const UPDATE_STATUS_CONVERSATION = 'UPDATE_STATUS_CONVERSATION';
export const UPDATE_CONVERSATION_SUCCESS = 'UPDATE_CONVERSATION_SUCCESS';
export const DELETE_CONVERSATION_LAST_MESSAGE_SUCCESS = 'DELETE_CONVERSATION_LAST_MESSAGE_SUCCESS';
export const HIDDEN_CONVERSATION_LAST_MESSAGE_SUCCESS = 'HIDDEN_CONVERSATION_LAST_MESSAGE_SUCCESS';
export const PATCH_IGNORE_CONVERSATION_SUCCESS = 'PATCH_IGNORE_CONVERSATION_SUCCESS';
export const GET_CONVERSATION_DETAIL = 'GET_CONVERSATION_DETAIL';
export const UPDATE_MODAL_DELETE = 'UPDATE_MODAL_DELETE';
export const UPDATE_LIST_CONVERSATION_IDS_DELETED = 'UPDATE_LIST_CONVERSATION_IDS_DELETED';
export const LOAD_CONVERSATION_DETAIL_SUCCESS = 'LOAD_CONVERSATION_DETAIL_SUCCESS';
export const LOAD_CONVERSATION_DETAIL_FAILURE = 'LOAD_CONVERSATION_DETAIL_FAILURE';
export const LOAD_CONVERSATION_DETAIL_PENDING = 'LOAD_CONVERSATION_DETAIL_PENDING';
export const LOAD_CONVERSATION_DETAIL_REQUEST = 'LOAD_CONVERSATION_DETAIL_REQUEST';
export const LOAD_CONVERSATION_DETAIL_REQUEST_SUCCESS = 'LOAD_CONVERSATION_DETAIL_REQUEST_SUCCESS';
export const LOAD_CONVERSATIONS_DETAIL_FAIL = 'LOAD_CONVERSATIONS_DETAIL_FAIL';
export const GET_OR_CREATE_CONVERSATIONS_FAIL = 'GET_OR_CREATE_CONVERSATIONS_FAIL';
export const RESET_GET_OR_CREATE_ERROR = 'RESET_GET_OR_CREATE_ERROR';
export const RESET_CONVERSATION_UNREAD_COUNT_SUCCESS = 'RESET_CONVERSATION_UNREAD_COUNT_SUCCESS';
export const RESET_SELECTED_PEERVCARD_AND_CONVERSATION_INFO_SUCCESS = 'RESET_SELECTED_PEERVCARD_AND_CONVERSATION_INFO_SUCCESS';
export const CHAT_UPDATE_MESSAGE_DELIVERED = 'CHAT_UPDATE_MESSAGE_DELIVERED';
export const CHAT_UPDATE_MESSAGE_READ = 'CHAT_UPDATE_MESSAGE_READ';
export const UPDATE_FILTER_CONVERSATIONS = 'UPDATE_FILTER_CONVERSATIONS';
export const GET_CONVERSATIONS_UNREAD_COUNT = 'GET_CONVERSATIONS_UNREAD_COUNT';
export const UPDATE_LOADING_CONVERSATION_DETAIL = 'UPDATE_LOADING_CONVERSATION_DETAIL';
export const CREATE_CONVERSATION_SUCCESS = 'CREATE_CONVERSATION_SUCCESS';
export const CREATE_CONVERSATION_FAILURE = 'CREATE_CONVERSATION_FAILURE';
export const CREATE_CONVERSATION_REQUEST = 'CREATE_CONVERSATION_REQUEST';
export const FILTER_CONVERSATIONS = 'FILTER_CONVERSATIONS';
export const UPDATE_FILTER_PARAMS_BY_DEFAULT_FOLDER = 'UPDATE_FILTER_PARAMS_BY_DEFAULT_FOLDER';
export const GET_PHOTOS_SUCCESS = 'GET_PHOTOS_SUCCESS';
export const GET_PHOTOS_DENIED = 'GET_PHOTOS_DENIED';
export const GET_CONVERSATION_STATUS_REQUEST = 'GET_CONVERSATION_STATUS_REQUEST';
export const GET_CONVERSATION_STATUS_FAILURE = 'GET_CONVERSATION_STATUS_FAILURE';
export const GET_CONVERSATION_STATUS = 'GET_CONVERSATION_STATUS';
export const CHECK_PIN_STATUS_CONVERSATION_SELECTED = 'CHECK_PIN_STATUS_CONVERSATION_SELECTED';
export const UPDATE_CONVERSATION_NAVIGATE_TYPE = 'UPDATE_CONVERSATION_NAVIGATE_TYPE';
export const LOAD_MAIN_AVATARS_SUCCESS = 'LOAD_MAIN_AVATARS_SUCCESS';
export const GET_MAIN_PHOTOS_REQUEST = 'GET_MAIN_PHOTOS_REQUEST';
export const GET_MAIN_PHOTO_REQUEST = 'GET_MAIN_PHOTO_REQUEST';
export const GET_MAIN_PHOTOS_FAILED = 'GET_MAIN_PHOTOS_FAILED';
export const GET_MAIN_PHOTOS_SUCCESS = 'GET_MAIN_PHOTOS_SUCCESS';
export const RETRY_LOAD_CONVERSATIONS = 'RETRY_LOAD_CONVERSATIONS';
export const SET_READ_CONVERSATION_REQUEST = 'SET_READ_CONVERSATION_REQUEST';
export const SET_READ_CONVERSATION_SUCCESS = 'SET_READ_CONVERSATION_SUCCESS';
export const SET_READ_CONVERSATION_FAILURE = 'SET_READ_CONVERSATION_FAILURE';
export const RETRYING_API_FAIL = 'RETRYING_API_FAIL';
export const RETRYING_API_FAIL_SUCCESS = 'RETRYING_API_FAIL_SUCCESS';
export const UPDATE_CONVERSATION_UNREAD = 'UPDATE_CONVERSATION_UNREAD';
export const UPDATE_MEMBER_LEVEL_CONVERSATION_SELECTED = 'UPDATE_MEMBER_LEVEL_CONVERSATION_SELECTED';
export const UPDATE_PARTICIPANT_COUNT = 'UPDATE_PARTICIPANT_COUNT';

export const SAVE_PEEVCARD = 'SAVE_PEEVCARD';
/* #region CONVERSATION */

// MESSAGE
export const DELETE_MESSAGE_SUCCESS = 'DELETE_MESSAGE_SUCCESS';
export const DELETE_MESSAGE_FAIL = 'DELETE_MESSAGE_FAIL';
export const UPDATE_USER_GROUPCHAT_MESSAGE = 'UPDATE_USER_GROUPCHAT_MESSAGE';
// MESSAGE

// POPUP
export const TOGGLE_REPORT_POPUP = 'TOGGLE_REPORT_POPUP';
export const TOGGLE_NO_PHOTO_POPUP = 'TOGGLE_NO_PHOTO_POPUP';
export const TOGGLE_REPORT_POPUP_POST = 'TOGGLE_REPORT_POPUP_POST';
export const TOGGLE_PROFILE_MODAL = 'TOGGLE_PROFILE_MODAL';
// POPUP

// ICE-BREAKER
export const LOAD_ICE_BREAKER_SUCCESS = 'LOAD_ICE_BREAKER_SUCCESS';
// ICE-BREAKER

// GIFT
export const LOAD_GIFTS_RECEIVED_SUCCESS = 'LOAD_GIFTS_RECEIVED_SUCCESS';
export const SELECT_GIFT_DATA = 'SELECT_GIFT_DATA';
export const LOADING_GIFTS_DATA = 'LOADING_GIFTS_DATA';
export const LOAD_GIFTS_DATA = 'LOAD_GIFTS_DATA';
export const LOAD_GIFT_CATEGORIES_DATA = 'LOAD_GIFT_CATEGORIES_DATA';
export const LOAD_GIFT_REPLIES_DATA = 'LOAD_GIFT_REPLIES_DATA';

// QUICK-MESSAGE
export const SELECT_QUICK_MESSAGE_SUCCESS = 'SELECT_QUICK_MESSAGE_SUCCESS';
export const LOAD_QUICK_MESSAGE_REQUEST = 'LOAD_QUICK_MESSAGE_REQUEST';
export const LOAD_QUICK_MESSAGE_FAILED = 'LOAD_QUICK_MESSAGE_FAILED';
export const LOAD_QUICK_MESSAGE_SUCCESS = 'LOAD_QUICK_MESSAGE_SUCCESS';
export const ADD_QUICK_MESSAGE_SUCCESS = 'ADD_QUICK_MESSAGE_SUCCESS';
export const UPDATE_QUICK_MESSAGE_SUCCESS = 'UPDATE_QUICK_MESSAGE_SUCCESS';
export const DELETE_QUICK_MESSAGE_SUCCESS = 'DELETE_QUICK_MESSAGE_SUCCESS';
// QUICK-MESSAGE

// PRIVATE-ALBUM
export const ADD_GRANTED_ALBUM = 'ADD_GRANTED_ALBUM';
export const GET_ALBUM_SUCCESS = 'GET_ALBUM_SUCCESS';
export const UPDATE_GALLERY_ACCESS = 'UPDATE_GALLERY_ACCESS';
export const GET_ALBUM_REQUEST = 'GET_ALBUM_REQUEST';
export const GET_ALBUM_FAILED = 'GET_ALBUM_FAILED';
export const GRANT_ACCESS_SUCCESS = 'GRANT_ACCESS_SUCCESS';
// PRIVATE-ALBUM

// user login type
export const USER_REQUEST_LOGIN = 'USER_REQUEST_LOGIN';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const UPDATE_LOGIN_REDUCER_STATE = 'UPDATE_LOGIN_REDUCER_STATE';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const UPDATE_CONNECTION_STATUS = 'UPDATE_CONNECTION_STATUS';
export const ATTEMPT_CONNECT_SUCCESS = 'ATTEMPT_CONNECT_SUCCESS';
export const TOGGLE_DISABLE_RECONNECTING_LABEL = 'TOGGLE_DISABLE_RECONNECTING_LABEL';
export const FIRST_CALL_API = 'FIRST_CALL_API';
export const GET_JIDRESOURCE_SUCCESS = 'GET_JIDRESOURCE_SUCCESS';
export const UPDATE_RETAIN_STATUS_SUCCESS = 'UPDATE_RETAIN_STATUS_SUCCESS';
export const UPDATE_LOGIN_STATE = 'UPDATE_LOGIN_STATE';
export const UPDATE_SUB_MENU_SELECTED = 'UPDATE_SUB_MENU_SELECTED';
export const UPDATE_STATE_USER_LOGIN = 'UPDATE_STATE_USER_LOGIN';

// user login type
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_REQUEST_USER_LOGIN_INFO_SUCCESS = 'USER_REQUEST_USER_LOGIN_INFO_SUCCESS';
export const USER_UPDATE_INFO_SUCCESS = 'USER_UPDATE_INFO_SUCCESS';
export const USER_UPDATE_JID = 'USER_UPDATE_JID';

// user login type
export const USER_REQUEST_REGISTER = 'USER_REQUEST_REGISTER';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';
export const UPDATE_ERROR_STATUS_LOGIN = 'UPDATE_ERROR_STATUS_LOGIN';
export const CONNECT_FACEBOOK_SUCCESS = 'CONNECT_FACEBOOK_SUCCESS';
export const UPDATE_STATUS_LOGIN_FB = 'UPDATE_STATUS_LOGIN_FB';
// chat type
export const CHAT_UPDATE_LAST_MESSAGE_CONVERSATION_READ = 'CHAT_UPDATE_LAST_MESSAGE_CONVERSATION_READ';
export const UPDATE_SELECT_PEER_C_CARD_STATUS = 'UPDATE_SELECT_PEER_C_CARD_STATUS';
export const UPDATE_DELETE_REFERENCE_MESSAGES = 'UPDATE_DELETE_REFERENCE_MESSAGES';
export const CHAT_UPDATE_MESSAGE_STATUS = 'CHAT_UPDATE_MESSAGE_STATUS';
export const RESET_MESSAGE_TO_INIT_DATA = 'RESET_MESSAGE_TO_INIT_DATA';
export const CHAT_UPDATE_MESSAGES_STATUS = 'CHAT_UPDATE_MESSAGES_STATUS';
export const CHAT_UPDATE_MESSAGE_FAIL = 'CHAT_UPDATE_MESSAGE_FAIL';
export const CHAT_REPLACE_MESSAGE_SUCCESS = 'CHAT_REPLACE_MESSAGE_SUCCESS';
export const CHAT_ADD_SEND_MESSAGE_SUCCESS = 'CHAT_ADD_SEND_MESSAGE_SUCCESS';
export const CHAT_ADD_RECEIVE_MESSAGE_SUCCESS = 'CHAT_ADD_RECEIVE_MESSAGE_SUCCESS';
export const CHAT_SEND_MESSAGE_READ_SUCCESS = 'CHAT_SEND_MESSAGE_READ_SUCCESS';
export const CHAT_DELETE_PEER_ALL_MESSAGES = 'CHAT_DELETE_PEER_ALL_MESSAGES';
export const CHAT_UPDATE_ALBUM_STATUS_SUCCESS = 'CHAT_UPDATE_ALBUM_STATUS_SUCCESS';
export const CHAT_REMOVE_ALBUM_STATUS_SUCCESS = 'CHAT_REMOVE_ALBUM_STATUS_SUCCESS';
export const REMOVE_MESSAGE_IN_QUEUE_TO_SEND = 'REMOVE_MESSAGE_IN_QUEUE_TO_SEND';
export const ADD_MESSAGE_TO_QUEUE_TO_SEND = 'ADD_MESSAGE_TO_QUEUE_TO_SEND';
export const UPDATE_MESSAGE_REDUCER = 'UPDATE_MESSAGE_REDUCER';
export const CHAT_UPDATE_MESSAGE_ERROR = 'CHAT_UPDATE_MESSAGE_ERROR';
export const CHAT_REMOVE_MESSAGE_ERROR = 'CHAT_REMOVE_MESSAGE_ERROR';
export const REMOVE_STATUS_ERROR_MESSAGE = 'REMOVE_STATUS_ERROR_MESSAGE';
export const UPDATE_DRAFT_MSG = 'UPDATE_DRAFT_MSG';
export const REMOVE_MESSAGE_SUCCESS = 'REMOVE_MESSAGE_SUCCESS';
export const CHAT_EDIT_TEXT_MESSAGE_SUCCESS = 'CHAT_EDIT_TEXT_MESSAGE_SUCCESS';
export const CHAT_EDIT_LAST_MESSAGE_CONVERSATION_SUCCESS = 'CHAT_EDIT_LAST_MESSAGE_CONVERSATION_SUCCESS';
export const REMOVE_MESSAGE_BY_USER_ID_AND_ROOM_JID_SUCCESS = 'REMOVE_MESSAGE_BY_USER_ID_AND_ROOM_JID_SUCCESS';
export const REMOVE_MESSAGE_BY_ROOM_JID_SUCCESS = 'REMOVE_MESSAGE_BY_ROOM_JID_SUCCESS';
export const MARK_EXPIRED_MESSAGE_INVITE_PRIVATE_GROUP_CHAT = 'MARK_EXPIRED_MESSAGE_INVITE_PRIVATE_GROUP_CHAT';
export const EXPIRE_MESSAGE_SUCCESS = 'EXPIRE_MESSAGE_SUCCESS';
export const UPDATE_MESSAGE_SENT = 'UPDATE_MESSAGE_SENT';
export const UPDATE_CONVERSATION_LAST_MESSAGE_SUCCESS = 'UPDATE_CONVERSATION_LAST_MESSAGE_SUCCESS';
export const SET_REQUEST_TYPE_CALL = 'SET_REQUEST_TYPE_CALL';

export const UPDATE_REACTION_MESSAGE_SUCCESS = 'UPDATE_REACTION_MESSAGE_SUCCESS';
export const STORE_REACTION_MESSAGE_SUCCESS = 'STORE_REACTION_MESSAGE_SUCCESS';

export const UPDATE_PROFILE_PHOTO_MESSAGE = 'UPDATE_PROFILE_PHOTO_MESSAGE';

// chat state type
export const CHAT_UPDATE_CHAT_STATE = 'CHAT_UPDATE_CHAT_STATE';
// chat group type
export const REMOVE_PUBLIC_GROUP_CHAT = 'REMOVE_PUBLIC_GROUP_CHAT';
export const CHAT_UPDATE_GROUP_SUCCESS = 'CHAT_UPDATE_GROUP_SUCCESS';
export const CHAT_UPDATE_ROOMS_DATA = 'CHAT_UPDATE_ROOMS_DATA';
export const SET_IS_SORT_LIVE_STREAM = 'SET_IS_SORT_LIVE_STREAM';
export const CHAT_UPDATE_GROUP_FAIL = 'CHAT_UPDATE_GROUP_FAIL';
export const UPDATE_BANNER_FREE_CHAT = 'UPDATE_BANNER_FREE_CHAT';
export const RESET_CLOSING_TIME_GROUP_CHAT = 'RESET_CLOSING_TIME_GROUP_CHAT';
export const CHAT_UPDATE_GROUP_REQUEST = 'CHAT_UPDATE_GROUP_REQUEST';

export const SET_PROFILE_NOTE_MEMBER_SUCCESS = 'SET_PROFILE_NOTE_MEMBER_SUCCESS';

export const JOIN_CHAT_ROOM_SUCCESS = 'JOIN_CHAT_ROOM_SUCCESS';
export const SET_NEXT_CHAT_ROOM_SUCCESS = 'SET_NEXT_CHAT_ROOM_SUCCESS';
export const QUIT_CHAT_ROOM_SUCCESS = 'QUIT_CHAT_ROOM_SUCCESS';
export const GET_ROOM_DETAIL_SUCCESS = 'GET_ROOM_DETAIL_SUCCESS';
export const GROUPCHAT_DELETE_ALL_MESSAGES = 'GROUPCHAT_DELETE_ALL_MESSAGES';
export const GET_ROOM_MEMBERS_DETAIL_REQUEST = 'GET_ROOM_MEMBERS_DETAIL_REQUEST';
export const GET_ROOM_MEMBERS_DETAIL = 'GET_ROOM_MEMBERS_DETAIL';
export const UPDATE_USER_STATUS_SUCCESS = 'UPDATE_USER_STATUS_SUCCESS';
export const UPDATE_USER_STATUS_LOCAL_SUCCESS = 'UPDATE_USER_STATUS_LOCAL_SUCCESS';
export const GET_LIST_USERS_STATUS_SUCCESS = 'GET_LIST_USERS_STATUS_SUCCESS';
export const CREATE_GROUP_CHAT_SUCCESS = 'CREATE_GROUP_CHAT_SUCCESS';
export const SET_WAITING_PROGRESS_GROUP_CHAT_SUCCESS = 'SET_WAITING_PROGRESS_GROUP_CHAT_SUCCESS';
export const UPDATE_WHISPER_STATUS_REALTIME = 'UPDATE_WHISPER_STATUS_REALTIME';
export const UPDATE_CHAT_ROOM_AUTHORIZED_SUCCESS = 'UPDATE_CHAT_ROOM_AUTHORIZED_SUCCESS';
export const BANNED_SUCCESS = 'BANNED_SUCCESS';
export const UPDATE_AL_READY_LOGGED = 'UPDATE_AL_READY_LOGGED';

// chat roster type
export const CHAT_UPDATE_ROSTER_SUCCESS = 'CHAT_UPDATE_ROSTER_SUCCESS';
export const CHAT_UPDATE_MY_ROSTER_SUCCESS = 'CHAT_UPDATE_MY_ROSTER_SUCCESS';

// chat subscribe type
export const CHAT_ADD_SUBSCRIBE_SUCCESS = 'CHAT_ADD_SUBSCRIBE_SUCCESS';
export const CHAT_REMOVE_SUBSCRIBE_SUCCESS = 'CHAT_REMOVE_SUBSCRIBE_SUCCESS';
// chat blacklist type
export const CHAT_UPDATE_BLACKLIST_SUCCESS = 'CHAT_UPDATE_BLACKLIST_SUCCESS';

// commom type
export const COMMON_FETCHING = 'COMMON_FETCHING';
export const COMMON_FETCHED = 'COMMON_FETCHED';
export const COMMON_UPDATE_TAB_BOTTOM_INDEX = 'COMMON_UPDATE_TAB_BOTTOM_INDEX';
export const COMMON_TRACKING_ROUTE = 'COMMON_TRACKING_ROUTE';

// FAVORITE
export const GET_FRIENDS_FAVORITES_REQUEST = 'GET_FRIENDS_FAVORITES_REQUEST';
export const GET_FRIENDS_FAVORITES_SUCCESS = 'GET_FRIENDS_FAVORITES_SUCCESS';
export const GET_FRIENDS_FAVORITES_FAILURE = 'GET_FRIENDS_FAVORITES_FAILURE';
export const GET_FRIENDS_FAVORITES = 'GET_FRIENDS_FAVORITES';
export const UPDATE_TEMP_DISPLAY_DATA_FRIEND_AND_FAV_SUCCESS = 'UPDATE_TEMP_DISPLAY_DATA_FRIEND_AND_FAV_SUCCESS';
export const UPDATE_TEMP_DATA_FRIEND_AND_FAV_TO_DISPLAY_SUCCESS = 'UPDATE_TEMP_DATA_FRIEND_AND_FAV_TO_DISPLAY_SUCCESS';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const ADD_FAVORITE = 'ADD_FAVORITE';
export const REMOVE_FAVORITE = 'REMOVE_FAVORITE';
export const LOAD_MORE_FRIENDS_FAVORITES = 'LOAD_MORE_FRIENDS_FAVORITES';

// FRIENDS VS FAVORITES
export const BLOCK_USER = 'BLOCK_USER';
export const UPDATE_FILTER_FRIEND_AND_FAVORITE = 'UPDATE_FILTER_FRIEND_AND_FAVORITE';

// REACTJS:
export const LOAD_SCREEN_MESSAGES_INBOX = 'LOAD_SCREEN_MESSAGES_INBOX';
export const LOAD_SCREEN_INBOX_DETAIL = 'LOAD_SCREEN_INBOX_DETAIL';
export const LOAD_SCREEN_GROUPS_CHAT = 'LOAD_SCREEN_GROUPS_CHAT';
export const LOAD_SCREEN_GROUP_CHAT_DETAIL = 'LOAD_SCREEN_GROUP_CHAT_DETAIL';

// USER
export const ADD_USER_PROFILE_SUCCESS = 'ADD_USER_PROFILE_SUCCESS';
export const GET_MATCHING_USERS_SUCCESS = 'GET_MATCHING_USERS_SUCCESS';
export const ADD_MATCHING_USER_SUCCESS = 'ADD_MATCHING_USER_SUCCESS';
export const CHECK_MATCHING_PROFILE_SUCCESS = 'CHECK_MATCHING_PROFILE_SUCCESS';
export const LOAD_SCREEN_USER_LOGIN = 'LOAD_SCREEN_USER_LOGIN';
export const GET_MAIN_PHOTO_SUCCESS = 'GET_MAIN_PHOTO_SUCCESS';
export const UPDATE_USERS_STATE_SUCCESS = 'UPDATE_USERS_STATE_SUCCESS';
export const USER_LOGIN_ACCOUNT_SUCCESS = 'USER_LOGIN_ACCOUNT_SUCCESS';
export const GET_PROFILE_GROUP_CHAT_SUCCESS = 'GET_PROFILE_GROUP_CHAT_SUCCESS';
export const GET_USERS_WHO_BLOCK_ME = 'GET_USERS_WHO_BLOCK_ME';
export const GET_USERS_BLOCKED = 'GET_USERS_BLOCKED';
// FACEBOOK
export const LOAD_SCREEN_FACE_BOOK_ACTIVE = 'LOAD_SCREEN_FACE_BOOK_ACTIVE';
export const FACE_BOOK_REGISTER_SUCCESS = 'FACE_BOOK_REGISTER_SUCCESS';
export const FACE_BOOK_LOGIN_SUCCESS = 'FACE_BOOK_LOGIN_SUCCESS';
export const FACE_BOOK_GET_USER_INFO_SUCCESS = 'FACE_BOOK_GET_USER_INFO_SUCCESS';
export const APPLE_LOGIN_SUCCESS = 'APPLE_LOGIN_SUCCESS';
export const GOOGLE_LOGIN_SUCCESS = 'GOOGLE_LOGIN_SUCCESS';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
// SPLASH
export const LOAD_SCREEN_SPLASH = 'LOAD_SCREEN_SPLASH';
export const UPDATE_STATE_LOADING_GET_CURRENT_POSITION_SUCCESS = 'UPDATE_STATE_LOADING_GET_CURRENT_POSITION_SUCCESS';

// LOCATION
export const LOAD_SCREEN_LOCATION_SELECTOR = 'LOAD_SCREEN_LOCATION_SELECTOR';
export const GET_DETAILS_PLACE_SUCCESS = 'GET_DETAILS_PLACE_SUCCESS';
export const UPDATE_CURRENT_LOCATION_SUCCESS = 'UPDATE_CURRENT_LOCATION_SUCCESS';
export const UPDATE_USER_DETAIL_LOCATION = 'UPDATE_USER_DETAIL_LOCATION';
// FOGOT PASSWORD
export const LOAD_SCREEN_FOGOT_PASSWORD = 'LOAD_SCREEN_FOGOT_PASSWORD';

// RESET PASSWORD
export const LOAD_SCREEN_RESET_PASSWORD = 'LOAD_SCREEN_RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const REQUEST_FORGOT_PASSWORD_SUCCESS = 'REQUEST_FORGOT_PASSWORD_SUCCESS';
// UPDATE_INFO
export const UPDATE_BACK_SCREEN_SUCCESS = 'UPDATE_BACK_SCREEN_SUCCESS';
export const ADD_REGISTRATION_PROPERTY_STATE = 'ADD_REGISTRATION_PROPERTY_STATE';

// LOOKING TO MEET
export const LTM_LOAD_SCREEN = 'LTM_LOAD_SCREEN';
export const LTM_LOAD_SCREEN_SUCCESS = 'LTM_LOAD_SCREEN_SUCCESS';
export const LTM_LOAD_LOOKING_FOR_SUCCESS = 'LTM_LOAD_LOOKING_FOR_SUCCESS';
export const LTM_LOAD_AGE_RANGE_SUCCESS = 'LTM_LOAD_AGE_RANGE_SUCCESS';
export const LTM_LOAD_INTENTIONS_SUCCESS = 'LTM_LOAD_INTENTIONS_SUCCESS';
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const UPDATE_INFO_BACK_SUCCESS = 'UPDATE_INFO_BACK_SUCCESS';
export const UPDATE_ACTION_CHANGE_CATEGORY_SUCCESS = 'UPDATE_ACTION_CHANGE_CATEGORY_SUCCESS';
export const LTM_CHANGE_CATEGORY_SUCCESS = 'LTM_CHANGE_CATEGORY_SUCCESS';
export const MPB_CHANGE_CATEGORY_SUCCESS = 'MPB_CHANGE_CATEGORY_SUCCESS';

// INTRODUCE YOURSELF
export const LOAD_INTRODUCE_YOURSELF_SCREEN = 'LOAD_INTRODUCE_YOURSELF_SCREEN';
export const LOAD_INTRODUCE_YOURSELF_SUCCESS = 'LOAD_INTRODUCE_YOURSELF_SUCCESS';
export const LOAD_PERSONALITY_DATA_SUCCESS = 'LOAD_PERSONALITY_DATA_SUCCESS';
export const LOAD_LOOK_DATA_SUCCESS = 'LOAD_LOOK_DATA_SUCCESS';
export const LOAD_INTERESTS_DATA_SUCCESS = 'LOAD_INTERESTS_DATA_SUCCESS';
export const LOAD_MPB_LOOKING_FOR_DATA_SUCCESS = 'LOAD_MPB_LOOKING_FOR_DATA_SUCCESS';
export const UPDATE_SELECTING_PROFILE_BUILDER_ITEM_SUCCESS = 'UPDATE_SELECTING_PROFILE_BUILDER_ITEM_SUCCESS';

// TELL US ABOUT YOURSELF 1
export const TU1_LOAD_SCREEN = 'TU1_LOAD_SCREEN';
export const TU1_LOAD_SEX_SUCCESS = 'TU1_LOAD_SEX_SUCCESS';
export const TU1_LOAD_AGE_SUCCESS = 'TU1_LOAD_AGE_SUCCESS';
export const TU1_LOAD_ETHNICITY_SUCCESS = 'TU1_LOAD_ETHNICITY_SUCCESS';
export const TU1_LOAD_RELATION_SHIP_SUCCESS = 'TU1_LOAD_RELATION_SHIP_SUCCESS';
export const UPDATE_MEMBER_TYPE_SUCCESS = 'UPDATE_MEMBER_TYPE_SUCCESS';
export const TU1_UPDATE_AGE_SUCCESS = 'TU1_UPDATE_AGE_SUCCESS';
export const TU1_UPDATE_HEIGHT_SUCCESS = 'TU1_UPDATE_HEIGHT_SUCCESS';

export const UPDATE_SELECTING_CATEGORY_SUCCESS = 'UPDATE_SELECTING_CATEGORY_SUCCESS';
export const SELECT_PROPERTY_ITEM_SUCCESS = 'SELECT_PROPERTY_ITEM_SUCCESS';
export const UPDATE_STATUS_LOAD_MORE_PROPERTY_ITEMS_SUCCESS = 'UPDATE_STATUS_LOAD_MORE_PROPERTY_ITEMS_SUCCESS';
export const UPDATE_AGE_RANGE = 'UPDATE_AGE_RANGE';
export const UPDATE_INDEX_TAB = 'UPDATE_INDEX_TAB';
export const UPDATE_MEMBER_TYPE = 'UPDATE_MEMBER_TYPE';

// TELL US ABOUT YOURSELF 2
export const LOAD_BODY_TYPES_DATA_SUCCESS = 'LOAD_BODY_TYPES_DATA_SUCCESS';
export const LOAD_HEIGHT_DATA_SUCCESS = 'LOAD_HEIGHT_DATA_SUCCESS';
export const LOAD_ORIENTATION_DATA_SUCCESS = 'LOAD_ORIENTATION_DATA_SUCCESS';
export const UPDATE_SUB_TAB_SUCCESS = 'UPDATE_SUB_TAB_SUCCESS';

// TELL US ABOUT YOURSELF 3
export const TU3_LOAD_GENERAL_SUCCESS = 'TU3_LOAD_GENERAL_SUCCESS';
export const TU3_LOAD_SEXUAL_SIGNLE_SUCCESS = 'TU3_LOAD_SEXUAL_SIGNLE_SUCCESS';
export const TU3_LOAD_SEXUAL_COUPLE_SUCCESS = 'TU3_LOAD_SEXUAL_COUPLE_SUCCESS';
export const TU3_LOAD_FETISH_SUCCESS = 'TU3_LOAD_FETISH_SUCCESS';

export const UPDATE_VALUE_SUCCESS = 'UPDATE_VALUE_SUCCESS';
export const UPDATE_CAN_NEXT_CATEGORY_SUCCESS = 'UPDATE_CAN_NEXT_CATEGORY_SUCCESS';

// SCREEN
export const PUSH_SCREEN_SUCCESS = 'Navigation/PUSH_SCREEN_SUCCESS';
export const POP_SCREEN_SUCCESS = 'Navigation/POP_SCREEN_SUCCESS';
export const RESET_SCREEN_SUCCESS = 'Navigation/RESET_SCREEN_SUCCESS';
export const INIT_ROUTES_SUCCESS = 'Navigation/INIT_ROUTES_SUCCESS';
export const UPDATE_APP_STATE_SUCCESS = 'UPDATE_APP_STATE_SUCCESS';
export const RESET_SCREEN = 'RESET_SCREEN';

// MEMBER SEARCH SCREEN
export const MEMBER_SEARCH = 'MEMBER_SEARCH_';
export const GET_USERS_MEMBER_SEARCH_SUCCESS = 'GET_USERS_MEMBER_SEARCH_SUCCESS';
export const GET_USERS_SPOTLIGHT_SUCCESS = 'GET_USERS_SPOTLIGHT_SUCCESS';
export const POST_USERS_MEMBER_SEARCH_SUCCESS = 'POST_USERS_MEMBER_SEARCH_SUCCESS';
export const POST_USERS_MEMBER_SEARCH_ACTION_SUCCESS = 'POST_USERS_MEMBER_SEARCH_ACTION_SUCCESS';
export const LOAD_MORE_USERS_MEMBER_SEARCH_SUCCESS = 'LOAD_MORE_USERS_MEMBER_SEARCH_SUCCESS';
export const GET_NICHE_SEARCH_SUCCESS = 'GET_NICHE_SEARCH_SUCCESS';
export const GET_NICHE_SEARCH_FAIL = 'GET_NICHE_SEARCH_FAIL';
export const UPDATE_REFINE_MODAL_STATUS = 'UPDATE_REFINE_MODAL_STATUS';
export const LOAD_SCREEN_MEMBER_SEARCH = 'LOAD_SCREEN_MEMBER_SEARCH';
export const SET_IN_USER_MEMBER_SEARCH = 'SET_IN_USER_MEMBER_SEARCH';
export const API_ERROR_SEARCH = 'API_ERROR_SEARCH';
export const RESET_DISCOVERY_ERROR_STATUS = 'RESET_DISCOVERY_ERROR_STATUS';
export const GET_USER_SAVED_SEARCHES_SUCCESS = 'GET_USER_SAVED_SEARCHES_SUCCESS';

// GET LIST FILTER ENTITIES MEMBER SEARCH
export const GET_USER_SEARCH_SETTINGS_SUCCESS = 'GET_USER_SEARCH_SETTINGS_SUCCESS';
export const GET_LIST_ENTITIES_SUCCESS = 'GET_LIST_ENTITIES_SUCCESS';
export const SHOW_ALERT_CONVERSATIONS_FILTER = 'SHOW_ALERT_CONVERSATIONS_FILTER';
export const GET_LIST_ENTITIES_FAIL = 'GET_LIST_ENTITIES_FAIL';
export const MS_LIST_INTENTION = 'MS_LIST_INTENTION';
export const MS_LIST_RELATIONSHIP_STATUS = 'MS_LIST_RELATIONSHIP_STATUS';
export const MS_LIST_BODY_TYPE = 'MS_LIST_BODY_TYPE';
export const MS_LIST_HEIGHT = 'MS_LIST_HEIGHT';
export const MS_LIST_ETHNICITY = 'MS_LIST_ETHNICITY';
export const MS_SEXUAL_ORIENTATION = 'MS_SEXUAL_ORIENTATION';
export const MS_SEXUAL_INTERESTS = 'MS_SEXUAL_INTERESTS';
export const UPDATE_STATE_MEMBER_SEARCH = 'UPDATE_STATE_MEMBER_SEARCH';
export const UPDATE_SORT_ORDER_TYPE = 'UPDATE_SORT_ORDER_TYPE';
export const MS_UPDATE_MEMBER_SEARCH = 'MS_UPDATE_MEMBER_SEARCH';
export const SET_STATE_ENTITIES_TAB_INDEX = 'SET_STATE_ENTITIES_TAB_INDEX';
export const RESET_FILTER_MEMBER_SEARCH = 'RESET_FILTER_MEMBER_SEARCH';
export const RESET_PREMIUM_FILTER = 'RESET_PREMIUM_FILTER';
export const RESET_SEARCH_FILTER = 'RESET_SEARCH_FILTER';
export const RESET_SEARCH_SPOTLIGHT_FILTER = 'RESET_SEARCH_SPOTLIGHT_FILTER';
export const DELETE_USER_MEMBER = 'DELETE_USER_MEMBER';

// MEMBER PROFILE SCREEN
export const GET_MEMBER_PROFILE_SUCCESS = 'GET_MEMBER_PROFILE_SUCCESS';
export const GET_MEMBER_PROFILE_VALIDATE_SUCCESS = 'GET_MEMBER_PROFILE_VALIDATE_SUCCESS';
export const GET_MEMBER_PROFILE_FRIENDS_SUCCESS = 'GET_MEMBER_PROFILE_FRIENDS_SUCCESS';
export const UPDATE_MEMBER_PROFILE_STATE = 'UPDATE_MEMBER_PROFILE_STATE';
export const UPDATE_MEMBER_PROFILE_PROPERTY_STATE = 'UPDATE_MEMBER_PROFILE_PROPERTY_STATE';
export const GET_MEMBER_PROFILE_ENTITIES_SUCCESS = 'GET_MEMBER_PROFILE_ENTITIES_SUCCESS';
export const POST_USERS_MEMBER_PROFILE_ACTION_SUCCESS = 'POST_USERS_MEMBER_PROFILE_ACTION_SUCCESS';
export const GET_MEMBER_PROFILE_TIME_OUT = 'GET_MEMBER_PROFILE_TIME_OUT';
export const MS_UPDATE_MEMBER_VIEW_PROFILES = 'MS_UPDATE_MEMBER_VIEW_PROFILES';
export const UPDATE_LIST_USERS_LIKED_SUCCESS = 'UPDATE_LIST_USERS_LIKED_SUCCESS';
export const UPDATE_MEMBER_PROFILE_TRAVEL_PLAN_SUCCESS = 'UPDATE_MEMBER_PROFILE_TRAVEL_PLAN_SUCCESS';

// USER STATUS
export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';
export const SET_STATUS_USER_IN_LIVE_STREAM = 'SET_STATUS_USER_IN_LIVE_STREAM';
export const SET_STATUS_USER_IN_VIDEO_CALL = 'SET_STATUS_USER_IN_VIDEO_CALL';
export const UPDATE_USER_LOGIN_STATE = 'UPDATE_USER_LOGIN_STATE';
export const SELECT_COUNTRY_PHONE_CODE_SUCCESS = 'SELECT_COUNTRY_PHONE_CODE_SUCCESS';
export const UNPAUSE_ACOUNT = 'UNPAUSE_ACOUNT';
// MODAL FOR VALIDATION
export const POST_MEMBER_CREATE_VALIDATION_SUCCESS = 'POST_MEMBER_CREATE_VALIDATION_SUCCESS';
export const POST_MEMBER_CREATE_FRIEND_SUCCESS = 'POST_MEMBER_CREATE_FRIEND_SUCCESS';
export const POST_MEMBER_CREATE_BLOCK_USER_SUCCESS = 'POST_MEMBER_CREATE_BLOCK_USER_SUCCESS';
//
export const TEMP_DATA_CAROUSEL = 'TEMP_DATA_CAROUSEL';

// MESSENGER SETTING
export const UPDATE_MESSENGER_PERMISSION_REQUEST = 'UPDATE_MESSENGER_PERMISSION_REQUEST ';
export const UPDATE_MESSENGER_PERMISSION_FAILED = 'UPDATE_MESSENGER_PERMISSION_FAILED ';
export const UPDATE_MESSENGER_PERMISSION_SUCCESS = 'UPDATE_MESSENGER_PERMISSION_SUCCESS ';
export const UPDATE_CHATROOM_MESSENGER_PERMISSION_SUCCESS = 'UPDATE_CHATROOM_MESSENGER_PERMISSION_SUCCESS ';
export const HIDE_STATUS_BAR = 'HIDE_STATUS_BAR ';
export const SHOW_STATUS_BAR = 'SHOW_STATUS_BAR ';

// VIDEO CALL

export const UPDATE_WINDOW_CALL_TYPE = 'UPDATE_WINDOW_CALL_TYPE';
export const UPDATE_RECEIVING_CALL_TYPE = 'UPDATE_RECEIVING_CALL_TYPE';
export const UPDATE_MUTED = 'UPDATE_MUTED';
export const UPDATE_CAMERA_MODE = 'UPDATE_CAMERA_MODE';
export const UPDATE_MIC = 'UPDATE_MIC';
export const UPDATE_VOICE_CALL = 'UPDATE_VOICE_CALL';
export const UPDATE_VOICE_CALL_PEER_USER = 'UPDATE_VOICE_CALL_PEER_USER';
export const UPDATE_STARTER = 'UPDATE_STARTER';
export const UPDATE_STATE_CALL = 'UPDATE_STATE_CALL';
export const CLEAN_UP_VIDEO_CALL = 'CLEAN_UP_VIDEO_CALL';
export const CALL_STATE_STARTED_BY = 'CALL_STATE_STARTED_BY';
export const SET_LOCAL_STREAM_SUCCESS = 'SET_LOCAL_STREAM_SUCCESS ';
export const SET_FRIEND_ID = 'SET_FRIEND_ID ';
export const SET_PEER_STREAM_SUCCESS = 'SET_PEER_STREAM_SUCCESS ';
export const CHANGE_STATUS_INCOMINGCALL = 'CHANGE_STATUS_INCOMINGCALL';
export const END_CALL_SUCCESS = 'END_CALL_SUCCESS';
export const ACCEPT_CALL_SUCCESS = 'ACCEPT_CALL_SUCCESS';
export const UPDATE_INTERRUPTID = 'UPDATE_INTERRUPTID';
export const UPDATE_LIST_VIDEO_DEVICES = 'UPDATE_LIST_VIDEO_DEVICES';
export const GET_CALLER_SUCCESS = 'GET_CALLER_SUCCESS';
export const GET_REQUEST_SUCCESS = 'GET_REQUEST_SUCCESS';
export const GET_CALL_SUCCESS = 'GET_CALL_SUCCESS';
export const CALL_ACTION_SUCCESS = 'CALL_ACTION_SUCCESS';
export const CHANGE_STATUS_VIDEO_CALL_WINDOW = 'CHANGE_STATUS_VIDEO_CALL_WINDOW';
export const UPDATE_VIDEO_CALL_STATE = 'UPDATE_VIDEO_CALL_STATE';
export const VIDEO_CALL_MINIMIZE = 'VIDEO_CALL_MINIMIZE';
export const VIDEO_CALL_FULLSCREEN = 'VIDEO_CALL_FULLSCREEN';
export const SWITCH_CARD_VIDEO_VIEW = 'SWITCH_CARD_VIDEO_VIEW';
export const SHOW_LOCAL_PHOTO_SUCCESS = 'SHOW_LOCAL_PHOTO_SUCCESS';
export const SHOW_PEER_PHOTO_SUCCESS = 'SHOW_PEER_PHOTO_SUCCESS';
export const SET_PEER_PHOTO_SUCCESS = 'SET_PEER_PHOTO_SUCCESS ';
export const COUNT_DOWN_OR_RESET_TIME_CALL = 'COUNT_DOWN_OR_RESET_TIME_CALL';
export const ADD_PEER_USER_CALL_INFO_SUCCESS = 'ADD_PEER_USER_CALL_INFO_SUCCESS';

// MEMBER PROSPECTS SCREEN
export const GET_USER_PROFILE_PROSPECTS_SUCCESS = 'GET_USER_PROFILE_PROSPECTS_SUCCESS';
export const GET_USER_PROFILE_PROSPECTS_ERROR = 'GET_USER_PROFILE_PROSPECTS_ERROR';
export const UPDATE_PROSPECTS = 'UPDATE_PROSPECTS';
export const LOAD_MORE_USER_PROFILE_PROSPECTS_SUCCESS = 'LOAD_MORE_USER_PROFILE_PROSPECTS_SUCCESS';
export const UPDATE_MEMBERTYPE_STATE_LIST = 'UPDATE_MEMBERTYPE_STATE_LIST';
export const GET_PROSPECTS_COUNT = 'GET_PROSPECTS_COUNT';
export const GET_PROSPECTS_COUNT_ERROR = 'GET_PROSPECTS_COUNT_ERROR';
export const UPDATE_ALL_MEMBERTYPE_STATE_LIST = 'UPDATE_ALL_MEMBERTYPE_STATE_LIST';
export const RESET_PROSPECTS_ERROR_STATUS = 'RESET_PROSPECTS_ERROR_STATUS';
export const GET_STATE_COUNT_SUCCESS = 'GET_STATE_COUNT_SUCCESS';
export const PROSPECTS_TIME_LOAD_INIT_DATA = 'PROSPECTS_TIME_LOAD_INIT_DATA';
// COMMON STATE REDUCER
export const UPDATE_CHAT_SERVER_TIME = 'UPDATE_CHAT_SERVER_TIME';
export const SHOW_REPORT_V2 = 'SHOW_REPORT_V2';
export const HIDE_REPORT_V2 = 'HIDE_REPORT_V2';
export const CLEAR_REPORT_V2_DATA = 'CLEAR_REPORT_V2_DATA';
export const UPDATE_MESSAGE_NOTIFICATION_ERROR = 'UPDATE_MESSAGE_NOTIFICATION_ERROR';
export const UPDATE_UNAVAILABLE_MESSENGER = 'UPDATE_UNAVAILABLE_MESSENGER';
export const UPDATE_UNAVAILABLE_CHATROOM = 'UPDATE_UNAVAILABLE_CHATROOM';
export const TOGGLE_MY_GROUPS_MODAL = 'TOGGLE_MY_GROUPS_MODAL';
export const TOGGLE_JOINED_GROUPS_MODAL = 'TOGGLE_JOINED_GROUPS_MODAL';
export const TOGGLE_GROUP_MEMBER_MODAL = 'TOGGLE_GROUP_MEMBER_MODAL';
export const TOGGLE_GLOBAL_PREVIEW_MEDIA_MODAL = 'TOGGLE_GLOBAL_PREVIEW_MEDIA_MODAL';
export const UPDATE_DATA_IN_APP_NOTIFICATION = 'UPDATE_DATA_IN_APP_NOTIFICATION';
export const SUPPORT_NOTIFICATION_MANAGER = 'SUPPORT_NOTIFICATION_MANAGER';
export const SET_IS_DESKTOP = 'SET_IS_DESKTOP';
export const RESET_DATA_IN_APP_NOTIFICATION = 'RESET_DATA_IN_APP_NOTIFICATION';
export const TOGGLE_CREATE_PASSWORD_MODAL = 'TOGGLE_CREATE_PASSWORD_MODAL';
export const TOGGLE_VERIFY_PASSWORD_MODAL = 'TOGGLE_VERIFY_PASSWORD_MODAL';
export const ADD_IN_APP_NOTIFICATION_TO_MANAGER = 'ADD_IN_APP_NOTIFICATION_TO_MANAGER';
export const REMOVE_IN_APP_NOTIFICATION_FROM_MANAGER = 'REMOVE_IN_APP_NOTIFICATION_FROM_MANAGER';
export const TOGGLE_IN_APP_NOTIFICATION = 'TOGGLE_IN_APP_NOTIFICATION';
export const DELETE_USER_PROFILE_VIEW_SUCCESS = 'DELETE_USER_PROFILE_VIEW_SUCCESS';
export const DELETE_LIST_USER_PROFILE_VIEW_SUCCESS = 'DELETE_LIST_USER_PROFILE_VIEW_SUCCESS';
export const DELETE_USER_LIKE_OR_MATCH_SUCCESS = 'DELETE_USER_LIKE_OR_MATCH_SUCCESS';
export const DELETE_LIST_USER_LIKE_OR_MATCH_SUCCESS = 'DELETE_LIST_USER_LIKE_OR_MATCH_SUCCESS';
export const SHOW_CONFIRM_MODAL = 'SHOW_CONFIRM_MODAL';
export const UPDATE_DATA_CONFIRM_MODAL = 'UPDATE_DATA_CONFIRM_MODAL';
export const UPDATE_COMMON_STATE_REDUCER = 'UPDATE_COMMON_STATE_REDUCER';
export const SHOW_NOTIFICATION_PHOTO_LIKE_MODAL = 'SHOW_NOTIFICATION_PHOTO_LIKE_MODAL';
export const HIDE_NOTIFICATION_PHOTO_LIKE_MODAL = 'HIDE_NOTIFICATION_PHOTO_LIKE_MODAL';
export const SHOW_NOTIFICATION_USER_INTEREST_MODAL = 'SHOW_NOTIFICATION_USER_INTEREST_MODAL';
export const HIDE_NOTIFICATION_USER_INTEREST_MODAL = 'HIDE_NOTIFICATION_USER_INTEREST_MODAL';
export const UPDATE_STATE_COMMON_STATE = 'UPDATE_STATE_COMMON_STATE';
export const TOGGLE_NOTIFICATION_GROUP_JOIN_REQUEST = 'TOGGLE_NOTIFICATION_GROUP_JOIN_REQUEST';
export const TOGGLE_NOTIFICATION_INVITATION = 'TOGGLE_NOTIFICATION_INVITATION';
export const TOGGLE_NOTIFICATION_GROUP_ACTIVITY = 'TOGGLE_NOTIFICATION_GROUP_ACTIVITY';
export const TOGGLE_NOTIFICATION_GROUP_JOINS = 'TOGGLE_NOTIFICATION_GROUP_JOINS';
export const TOGGLE_SENSITIVE_MODAL = 'TOGGLE_SENSITIVE_MODAL';
export const TOGGLE_SHARE_URL_MODAL = 'TOGGLE_SHARE_URL_MODAL';
export const UPDATE_ERROR_API = 'UPDATE_ERROR_API';
export const GET_ABOUT_RHP_REQUEST = 'GET_ABOUT_RHP_REQUEST';
export const GET_ABOUT_RHP_SUCCESS = 'GET_ABOUT_RHP_SUCCESS';
export const GET_ABOUT_RHP_FAILED = 'GET_ABOUT_RHP_FAILED';
export const GET_SEARCH_FRIEND_ONLINE_REQUEST = 'GET_SEARCH_FRIEND_ONLINE_REQUEST';
export const GET_SEARCH_FRIEND_ONLINE_SUCCESS = 'GET_SEARCH_FRIEND_ONLINE_SUCCESS';
export const GET_SEARCH_FRIEND_ONLINE_FAILED = 'GET_SEARCH_FRIEND_ONLINE_FAILED';
export const GET_SEARCH_FAVOURITES_ONLINE_REQUEST = 'GET_SEARCH_FAVOURITES_ONLINE_REQUEST';
export const GET_SEARCH_FAVOURITES_ONLINE_SUCCESS = 'GET_SEARCH_FAVOURITES_ONLINE_SUCCESS';
export const GET_SEARCH_FAVOURITES_ONLINE_FAILED = 'GET_SEARCH_FAVOURITES_ONLINE_FAILED';
// NEW FEED REDUCER GET_DATA_HOME_PAGE_SUCCESS
export const GET_DATA_HOME_PAGE_SUCCESS = 'GET_DATA_HOME_PAGE_SUCCESS';
export const MERGE_DATA_HOME_PAGE_SUCCESS = 'MERGE_DATA_HOME_PAGE_SUCCESS';
export const GET_ACTIVITY_SUMARY_USERS_SUCCESS = 'GET_ACTIVITY_SUMARY_USERS_SUCCESS';
export const GET_DATA_HOME_PAGE_ERROR = 'GET_DATA_HOME_PAGE_ERROR';
export const UPDATE_NEW_FEED_STATE = 'UPDATE_NEW_FEED_STATE';
export const RESET_HOME_ERROR_STATUS = 'RESET_HOME_ERROR_STATUS';
export const GET_RECENT_SUCCESS = 'GET_RECENT_SUCCESS';
export const GET_ANNOUNCEMENT_BANNER_SUCCESS = 'GET_ANNOUNCEMENT_BANNER_SUCCESS';
export const TOGGLE_TESTIMONIAL_MODAL = 'TOGGLE_TESTIMONIAL_MODAL';
// LIVE STREAM
export const GET_LIST_LIVE_STREAM_SUCCESS = 'GET_LIST_LIVE_STREAM_SUCCESS';
export const SET_LIST_CURRENT_LIVE_STREAM_SUCCESS = 'SET_LIST_CURRENT_LIVE_STREAM_SUCCESS';
export const UPDATE_LIVE_MEMBER = 'UPDATE_LIVE_MEMBER';
export const ADD_NEW_LIVE_STREAM_SUCCESS = 'ADD_NEW_LIVE_STREAM_SUCCESS';
export const REMOVE_LIVE_STREAM_SUCCESS = 'REMOVE_LIVE_STREAM_SUCCESS';
export const GET_LIST_LIVE_STREAM_IN_ROOM_SUCCESS = 'GET_LIST_LIVE_STREAM_IN_ROOM_SUCCESS';

export const ADD_VIEWER_VIEW_LIVE_STREAM = 'ADD_VIEWER_VIEW_LIVE_STREAM';
export const REMOVE_VIEWER_VIEW_LIVE_STREAM = 'REMOVE_VIEWER_VIEW_LIVE_STREAM';

export const GET_STREAM_DETAIL_SUCCESS = 'GET_STREAM_DETAIL_SUCCESS';
export const SELECT_STREAM_IN_ROOM_SUCCESS = 'SELECT_STREAM_IN_ROOM_SUCCESS';
export const SELECT_STREAM_PUBLISHER_IN_ROOM_SUCCESS = 'SELECT_STREAM_PUBLISHER_IN_ROOM_SUCCESS';
export const WATCH_LIVE_STREAM_SUCCESS = 'WATCH_LIVE_STREAM_SUCCESS';
export const ADD_NEW_WATCHER_SUCCESS = 'ADD_NEW_WATCHER_SUCCESS';
export const REMOVE_WATCHER_SUCCESS = 'REMOVE_WATCHER_SUCCESS';
export const RESET_SELECTED_STREAM = 'RESET_SELECTED_STREAM';
export const RESET_LIVE_STREAM_IN_ROOM = 'RESET_LIVE_STREAM_IN_ROOM';
export const CREATE_PUBLIC_LIVE_STREAM_SUCCESS = 'CREATE_PUBLIC_LIVE_STREAM_SUCCESS';
export const CREATE_PUBLIC_LIVE_STREAM_FAILURE = 'CREATE_PUBLIC_LIVE_STREAM_FAILURE';
export const QUIT_PUBLIC_LIVE_STREAM_SUCCESS = 'QUIT_PUBLIC_LIVE_STREAM_SUCCESS';
export const SELECT_PUBLIC_LIVE_STREAM_SUCCESS = 'SELECT_PUBLIC_LIVE_STREAM_SUCCESS';
export const GET_PUBLIC_STREAM_DETAIL_SUCCESS = 'GET_PUBLIC_STREAM_DETAIL_SUCCESS';
export const SHOW_ALERT_STOPPED_PUBLIC_STREAM_DETAIL_SUCCESS = 'SHOW_ALERT_STOPPED_PUBLIC_STREAM_DETAIL_SUCCESS';
export const SET_WAITING_PROGRESS_PUBLIC_LIVE_STREAM_SUCCESS = 'SET_WAITING_PROGRESS_PUBLIC_LIVE_STREAM_SUCCESS';

// NOTIFICATION
export const GET_ALERT_SUCCESS = 'GET_ALERT_SUCCESS';
export const GET_EVENT_USER_EXPRESS_INTEREST_SUCCESS = 'GET_EVENT_USER_EXPRESS_INTEREST_SUCCESS';
export const GET_ALERT_NOTIFICATION_SUCCESS = 'GET_ALERT_NOTIFICATION_SUCCESS';
export const GET_VALIDATION_NOTIFICATION_SUCCESS = 'GET_VALIDATION_NOTIFICATION_SUCCESS';
export const GET_GROUP_INVITATION_NOTIFICATION_SUCCESS = 'GET_GROUP_INVITATION_NOTIFICATION_SUCCESS';
export const GET_EVENT_INVITATION_NOTIFICATION_SUCCESS = 'GET_EVENT_INVITATION_NOTIFICATION_SUCCESS';
export const GET_PHOTO_LIKES_NOTIFICATION_SUCCESS = 'GET_PHOTO_LIKES_NOTIFICATION_SUCCESS';
export const GET_FRIEND_NOTIFICATION_SUCCESS = 'GET_FRIEND_NOTIFICATION_SUCCESS';
export const GET_DATEFINDER_NOTIFICATION_SUCCESS = 'GET_DATEFINDER_NOTIFICATION_SUCCESS';
export const GET_DATEFINDER_INTEREST_SUCCESS = 'GET_DATEFINDER_INTEREST_SUCCESS';
export const MERGE_DATA_NOTIFICATION_SUCCESS = 'MERGE_DATA_NOTIFICATION_SUCCESS';
export const PATCH_ACTION_NOTIFICATION_SUCCESS = 'PATCH_ACTION_NOTIFICATION_SUCCESS';
export const PATCH_ACTION_INTEREST_SUCCESS = 'PATCH_ACTION_INTEREST_SUCCESS';
export const DELETE_USER_FRIENDS = 'DELETE_USER_FRIENDS';
export const DELETE_NOTIFICATION_ALERT = 'DELETE_NOTIFICATION_ALERT';
export const RESET_ALL_DATA = 'RESET_ALL_DATA';
export const GET_GROUP_USER_ACTIVITIES_SUCCESS = 'GET_GROUP_USER_ACTIVITIES_SUCCESS';
export const GET_GROUP_JOIN_REQUEST_SUCCESS = 'GET_GROUP_JOIN_REQUEST_SUCCESS';

// MEMBER_TYPE_PLURAL
export const GET_MEMBER_TYPE_PLURAL_REQUEST = 'GET_MEMBER_TYPE_PLURAL_REQUEST';
export const GET_MEMBER_TYPE_PLURAL_FAILURE = 'GET_MEMBER_TYPE_PLURAL_FAILURE';
export const GET_MEMBER_TYPE_PLURAL_SUCCESS = 'GET_MEMBER_TYPE_PLURAL_SUCCESS';

// USER SEARCH SETTING GLOBAL
export const GET_COMMON_USER_SEARCH_SETTING_REQUEST = 'GET_COMMON_USER_SEARCH_SETTING_REQUEST';
export const GET_COMMON_USER_SEARCH_SETTING_FAILURE = 'GET_COMMON_USER_SEARCH_SETTING_FAILURE';
export const GET_COMMON_USER_SEARCH_SETTING_SUCCESS = 'GET_COMMON_USER_SEARCH_SETTING_SUCCESS';
// EVENT
export const GET_EVENT_SEARCH_SUCCESS = 'GET_EVENT_SEARCH_SUCCESS';
export const GET_EVENT_SEARCH_SPONSORED_SUCCESS = 'GET_EVENT_SEARCH_SPONSORED_SUCCESS';
export const GET_EVENT_CATEGORY_SUCCESS = 'GET_EVENT_CATEGORY_SUCCESS';
export const GET_CLUB_CATEGORY_SUCCESS = 'GET_CLUB_CATEGORY_SUCCESS';
export const TOGGLE_CREATE_EDIT_EVENT_MODAL = 'TOGGLE_CREATE_EDIT_EVENT_MODAL';
export const TOGGLE_MY_EVENTS_MODAL = 'TOGGLE_MY_EVENTS_MODAL';
export const TOGGLE_INTERESTED_IN_EVENT_DESKTOP_MODAL = 'TOGGLE_INTERESTED_IN_EVENT_DESKTOP_MODAL';
export const TOGGLE_INTERESTED_IN_USER_EVENT_DESKTOP_MODAL = 'TOGGLE_INTERESTED_IN_USER_EVENT_DESKTOP_MODAL';
export const GET_TIMEZONE_SUCCESS = 'GET_TIMEZONE_SUCCESS';
export const POST_SHOW_HIDDEN_TICKET_LINK = 'POST_SHOW_HIDDEN_TICKET_LINK';
export const POST_INVITE_REMOVE_GROUP_CHAT = 'POST_INVITE_REMOVE_GROUP_CHAT';
export const DELETE_ALL_USER_EVENT_GROUP_CHAT = 'DELETE_ALL_USER_EVENT_GROUP_CHAT';
export const GET_EVENT_INTERESTED_SUCCESS = 'GET_EVENT_INTERESTED_SUCCESS';

export const GET_USER_EVENT_SUCCESS = 'GET_USER_EVENT_SUCCESS';
export const GET_SHARE_MY_EVENT_SUCCESS = 'GET_SHARE_MY_EVENT_SUCCESS';
export const GET_CLUB_EVENT_SUCCESS = 'GET_CLUB_EVENT_SUCCESS';
export const GET_MY_USER_EVENT_SUCCESS = 'GET_MY_USER_EVENT_SUCCESS';
export const GET_USER_INTEREST_EVENT_SUCCESS = 'GET_USER_INTEREST_EVENT_SUCCESS';
export const GET_EVENT_INTEREST_SUCCESS = 'GET_EVENT_INTEREST_SUCCESS';
export const DELETE_EVENT_INTEREST_SUCCESS = 'DELETE_EVENT_INTEREST_SUCCESS';
export const GET_EVENT_DETAIL_SUCCESS = 'GET_EVENT_DETAIL_SUCCESS';
export const GET_EVENT_COMMENT_SUCCESS = 'GET_EVENT_COMMENT_SUCCESS';
export const GET_EVENT_CLUB_SUCCESS = 'GET_EVENT_CLUB_SUCCESS';
export const POST_CREATE_EVENT_SUCCESS = 'POST_CREATE_EVENT_SUCCESS';
export const POST_CREATE_EVENT_INTEREST_SUCCESS = 'POST_CREATE_EVENT_INTEREST_SUCCESS';
export const POST_CREATE_EVENT_COMMENT_SUCCESS = 'POST_CREATE_EVENT_COMMENT_SUCCESS';
export const DELETE_EVENT_COMMENT_SUCCESS = 'DELETE_EVENT_COMMENT_SUCCESS';
export const PATCH_DELETE_EVENT_SUCCESS = 'PATCH_DELETE_EVENT_SUCCESS';
export const PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS = 'PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS';
export const PATCH_DELETE_USER_EVENT_INTERESTED_SUCCESS = 'PATCH_DELETE_USER_EVENT_INTERESTED_SUCCESS';
export const PATCH_UPDATE_MY_USER_EVENT_SUCCESS = 'PATCH_UPDATE_MY_USER_EVENT_SUCCESS';
export const MERGE_DATA_EVENT_SUCCESS = 'MERGE_DATA_EVENT_SUCCESS';
export const UPDATE_STATE_EVENT_HOME = 'UPDATE_STATE_EVENT_HOME';
export const SET_STATE_ENTITIES_TYPE_GUEST = 'SET_STATE_ENTITIES_TYPE_GUEST';
export const GET_EVENT_REPLY_SUCCESS = 'GET_EVENT_REPLY_SUCCESS';
export const GET_EVENT_REPLY_SHOW_MORE_SHOW_LESS = 'GET_EVENT_REPLY_SHOW_MORE_SHOW_LESS';
export const GET_EVENT_POPULAR_COUNT_SUCCESS = 'GET_EVENT_POPULAR_COUNT_SUCCESS';
export const GET_ACTIVE_USER_POPULAR_COUNT_SUCCESS = 'GET_ACTIVE_USER_POPULAR_COUNT_SUCCESS';
export const GET_CLUB_COUNT_SUCCESS = 'GET_CLUB_COUNT_SUCCESS';
export const POST_CREATE_COMMENT_LIKE_SUCCESS = 'POST_CREATE_COMMENT_LIKE_SUCCESS';
export const DELETE_COMMENT_LIKE_SUCCESS = 'DELETE_COMMENT_LIKE_SUCCESS';
export const REQUEST_GET_DETAIL_CLUB_EVENT = 'REQUEST_GET_DETAIL_CLUB_EVENT';
export const GET_DETAIL_CLUB_EVENT_FAIL = 'GET_DETAIL_CLUB_EVENT_FAIL';
export const GET_DETAIL_CLUB_EVENT_SUCCESS = 'GET_DETAIL_CLUB_EVENT_SUCCESS';
export const GET_PHOTO_DETAIL_CLUB_SUCCESS = 'GET_PHOTO_DETAIL_CLUB_SUCCESS';
export const CLOSE_CLUB_DETAIL = 'CLOSE_CLUB_DETAIL';
export const DELETE_PARENT_OWNED_COMMENT = 'DELETE_PARENT_OWNED_COMMENT';
export const DELETE_THREAD_MESSAGE = 'DELETE_THREAD_MESSAGE';

// PUBLIC LIVE STEAMS
export const GET_PUBLIC_LIVE_STREAMS_REQUEST = 'GET_PUBLIC_LIVE_STREAMS_REQUEST';
export const GET_PUBLIC_LIVE_STREAMS_FAILURE = 'GET_PUBLIC_LIVE_STREAMS_FAILURE';
export const GET_PUBLIC_LIVE_STREAMS_SUCCESS = 'GET_PUBLIC_LIVE_STREAMS_SUCCESS';
export const GET_MORE_PUBLIC_LIVE_STREAMS_SUCCESS = 'GET_MORE_PUBLIC_LIVE_STREAMS_SUCCESS';
export const GET_LIST_VIEWERS_STATUS_SUCCESS = 'GET_LIST_VIEWERS_STATUS_SUCCESS';
export const UPDATE_USER_STATUS_LIVE_SUCCESS = 'UPDATE_USER_STATUS_LIVE_SUCCESS';
export const CHANGE_PUBLIC_LIVE_STREAMS_FILTERED = 'CHANGE_PUBLIC_LIVE_STREAMS_FILTERED';

// MESSAGE SUMMARY
export const UPDATE_UNREAD_MESSAGE_ALL_SUCCESS = 'UPDATE_UNREAD_MESSAGE_ALL_SUCCESS';

// SCREEN ORIENTATION
export const UPDATE_ORIENTATION_SCREEN = 'UPDATE_ORIENTATION_SCREEN';
export const UPDATE_PREVIOUS_SCREEN = 'UPDATE_PREVIOUS_SCREEN';
export const UPDATE_STATUS_SHOULD_SELECT_CONVERSATION_SCREEN = 'UPDATE_STATUS_SHOULD_SELECT_CONVERSATION_SCREEN';
export const UPDATE_USERID_SHOULD_SELECT_ON_MESSENGER_SCREEN = 'UPDATE_USERID_SHOULD_SELECT_ON_MESSENGER_SCREEN';
export const RESET_USERID_SHOULD_SELECT_ON_MESSENGER_SCREEN = 'RESET_USERID_SHOULD_SELECT_ON_MESSENGER_SCREEN';

// Folder
export const ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_REQUEST = 'ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_REQUEST';
export const ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_FAILURE = 'ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_FAILURE';
export const ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_SUCCESS = 'ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_SUCCESS';

export const GET_FOLDERS_REQUEST = 'GET_FOLDERS_REQUEST';
export const GET_FOLDERS_FAILURE = 'GET_FOLDERS_FAILURE';
export const GET_FOLDERS_SUCCESS = 'GET_FOLDERS_SUCCESS';

export const CREATE_FOLDER_REQUEST = 'CREATE_FOLDER_REQUEST';
export const CREATE_FOLDER_FAILURE = 'CREATE_FOLDER_FAILURE';
export const CREATE_FOLDER_SUCCESS = 'CREATE_FOLDER_SUCCESS';

export const UPDATE_FOLDER_REQUEST = 'UPDATE_FOLDER_REQUEST';
export const UPDATE_FOLDER_FAILURE = 'UPDATE_FOLDER_FAILURE';
export const UPDATE_FOLDER_SUCCESS = 'UPDATE_FOLDER_SUCCESS';

export const DELETE_FOLDER_REQUEST = 'DELETE_FOLDER_REQUEST';
export const DELETE_FOLDER_FAILURE = 'DELETE_FOLDER_FAILURE';
export const DELETE_FOLDER_SUCCESS = 'DELETE_FOLDER_SUCCESS';

export const UPDATE_CONVERSATION_GROUP_COVER_URL = 'UPDATE_CONVERSATION_GROUP_COVER_URL';
export const UPDATE_CONVERSATION_USER_BOOST_EXPIRY_TIME = 'UPDATE_CONVERSATION_USER_BOOST_EXPIRY_TIME';
export const UPDATE_CONVERSATION_BUDDY_BOOST_EXPIRY_TIME = 'UPDATE_CONVERSATION_BUDDY_BOOST_EXPIRY_TIME';
export const UPDATE_CONVERSATION_SEARCH = 'UPDATE_CONVERSATION_SEARCH';
export const UPDATE_STATE_CONVERSATION_SEARCH = 'UPDATE_STATE_CONVERSATION_SEARCH';

export const ADD_CONVERSATION_TO_FOLDER_REQUEST = 'ADD_CONVERSATION_TO_FOLDER_REQUEST';
export const ADD_CONVERSATION_TO_FOLDER_FAILURE = 'ADD_CONVERSATION_TO_FOLDER_FAILURE';
export const ADD_CONVERSATION_TO_FOLDER_SUCCESS = 'ADD_CONVERSATION_TO_FOLDER_SUCCESS';

export const LOADING_PUBLIC_GROUP_CHAT_MEMBER = 'LOADING_PUBLIC_GROUP_CHAT_MEMBER';
export const ADD_JOINING_MEMBER_PUBLIC_GROUP_CHAT = 'ADD_JOINING_MEMBER_PUBLIC_GROUP_CHAT';
export const REMOVE_JOINING_MEMBER_PUBLIC_GROUP_CHAT = 'REMOVE_JOINING_MEMBER_PUBLIC_GROUP_CHAT';
export const CLEAR_JOINING_MEMBER_PUBLIC_GROUP_CHAT = 'CLEAR_JOINING_MEMBER_PUBLIC_GROUP_CHAT';

export const UPDATE_IS_STREAMING = 'UPDATE_IS_STREAMING';

export const REMOVE_CONVERSATION_FROM_FOLDER_REQUEST = 'REMOVE_CONVERSATION_FROM_FOLDER_REQUEST';
export const REMOVE_CONVERSATION_FROM_FOLDER_FAILURE = 'REMOVE_CONVERSATION_FROM_FOLDER_FAILURE';
export const REMOVE_CONVERSATION_FROM_FOLDER_SUCCESS = 'REMOVE_CONVERSATION_FROM_FOLDER_SUCCESS';

export const SELECT_FOLDER_SUCCESS = 'SELECT_FOLDER_SUCCESS';

export const GET_NOTIFICATION_COUNT_FOR_NEW_FEED_SUCCESS = 'GET_NOTIFICATION_COUNT_FOR_NEW_FEED_SUCCESS';
export const GET_NOTIFICATION_COUNT_FOR_PROSPECT = 'GET_NOTIFICATION_COUNT_FOR_PROSPECT';
export const UPDATE_STATE_NOTIFICATION_COUNT = 'UPDATE_STATE_NOTIFICATION_COUNT';
export const UPDATE_COUNT_FOR_NEW_VIEWS = 'UPDATE_COUNT_FOR_NEW_VIEWS';
export const UPDATE_COUNT_FOR_NEW_MATCHES = 'UPDATE_COUNT_FOR_NEW_MATCHES';
export const UPDATE_COUNT_FOR_NEW_FAVOURITES = 'UPDATE_COUNT_FOR_NEW_FAVOURITES';
export const UPDATE_COUNT_FOR_NEW_LIKES = 'UPDATE_COUNT_FOR_NEW_LIKES';
// Edit Profile
export const GET_GALLERIES_REQUEST = 'GET_GALLERIES_REQUEST';
export const GET_USER_PHOTO_REQUEST = 'GET_USER_PHOTO_REQUEST';
export const GET_GALLERIES_SUCCESS = 'GET_GALLERIES_SUCCESS';
export const GET_USER_PHOTO_SUCCESS = 'GET_USER_PHOTO_SUCCESS';
export const GET_USER_PROFILE_PHOTO_SUCCESS = 'GET_USER_PROFILE_PHOTO_SUCCESS';
export const SET_LOADED_ALL_GENERAL_DETAILS_SUCCESS = 'SET_LOADED_ALL_GENERAL_DETAILS_SUCCESS';
export const GET_PROPERTY_SUCCESS = 'GET_PROPERTY_SUCCESS';
export const GET_PROPERTY_PROFILE_BUILDER = 'GET_PROPERTY_PROFILE_BUILDER';
export const GET_INTEREST_PROPERTY_SUCCESS = 'GET_INTEREST_PROPERTY_SUCCESS';
export const PATCH_UPDATE_USER_PHOTO_SUCCESS = 'PATCH_UPDATE_USER_PHOTO_SUCCESS';
export const UPLOAD_PHOTO_SUCCESS = 'UPLOAD_PHOTO_SUCCESS';
export const RESET_USER_PHOTO = 'RESET_USER_PHOTO';
export const RESET_STATUS_LOADED_PHOTO_AND_DATA = 'RESET_STATUS_LOADED_PHOTO_AND_DATA';
export const POST_VERIFICATION_SUCCESS = 'POST_VERIFICATION_SUCCESS';
export const DELETE_VALIDATION_SUCCESS = 'DELETE_VALIDATION_SUCCESS';
export const APPROVE_VALIDATION_SUCCESS = 'APPROVE_VALIDATION_SUCCESS';
export const UPDATE_EDIT_PROFILE_STATE = 'UPDATE_EDIT_PROFILE_STATE';
export const UPDATE_STATE_EDIT_PROFILE_WITH_KEY = 'UPDATE_STATE_EDIT_PROFILE_WITH_KEY';
// Header desktop
export const UPDATE_MENU_SELECTED = 'UPDATE_MENU_SELECTED';
// My List
export const UPDATE_VALIDATION_STATE = 'UPDATE_VALIDATION_STATE';
export const GET_VALIDATION_SUCCESS = 'GET_VALIDATION_SUCCESS';
//
export const UPDATE_BLOCK_LIST_STATE = 'UPDATE_BLOCK_LIST_STATE';
export const GET_BLOCK_LIST_SUCCESS = 'GET_BLOCK_LIST_ACCESS';
export const DELETE_BLOCK_SUCCESS = 'DELETE_BLOCK_SUCCESS';

// User actives
export const GET_ACTIVE_USERS_REQUEST = 'GET_ACTIVE_USERS_REQUEST';
export const GET_ACTIVE_USERS_BY_FILTER_REQUEST = 'GET_ACTIVE_USERS_BY_FILTER_REQUEST';
export const TOGGLE_HAS_FILTERED_USERS_ACTIVE_STATUS = 'TOGGLE_HAS_FILTERED_USERS_ACTIVE_STATUS';
export const GET_ACTIVE_USERS_SUCCESS = 'GET_ACTIVE_USERS_SUCCESS';
export const GET_ACTIVE_USERS_FILTERED_SUCCESS = 'GET_ACTIVE_USERS_FILTERED_SUCCESS';
export const GET_ACTIVE_USERS_FAILED = 'GET_ACTIVE_USERS_FAILED';
export const GET_ACTIVE_USERS_FILTERED_FAILED = 'GET_ACTIVE_USERS_FILTERED_FAILED';

//
export const UPDATE_HIDDEN_LIST_STATE = 'UPDATE_HIDDEN_LIST_STATE';
export const GET_HIDDEN_LIST_SUCCESS = 'GET_HIDDEN_LIST_SUCCESS';
export const DELETE_HIDDEN_LIST_SUCCESS = 'DELETE_HIDDEN_LIST_SUCCESS';
export const DELETE_ALL_PROFILE_HIDDEN_SUCCESS = 'DELETE_ALL_PROFILE_HIDDEN_SUCCESS';
//
export const UPDATE_PRIVATE_ALBUM_ACCESS_STATE = 'UPDATE_PRIVATE_ALBUM_ACCESS_STATE';
export const GET_PRIVATE_ALBUM_ACCESS_SUCCESS = 'GET_PRIVATE_ALBUM_ACCESS_SUCCESS';
export const UPDATE_PRIVATE_ALBUM_ACCESS_SUCCESS = 'UPDATE_PRIVATE_ALBUM_ACCESS_SUCCESS';
export const UPDATE_PRIVATE_ALBUM_STATUS_SUCCESS = 'UPDATE_PRIVATE_ALBUM_STATUS_SUCCESS';

// export const GRANTED_PRIVATE_ALBUM_SUCCESS = 'GRANTED_PRIVATE_ALBUM_SUCCESS';

export const CREATE_USER_TOOLTIP_SUCCESS = 'CREATE_USER_TOOLTIP_SUCCESS';
export const INCREASE_TOOLTIP_VIEW_COUNT_FACE_ID = 'INCREASE_TOOLTIP_VIEW_COUNT_FACE_ID';

// PAYMENT GATEWAY
export const UPDATE_STATE_PAYMENT_GATEWAY = 'UPDATE_STATE_PAYMENT_GATEWAY';
export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS';
export const UPDATE_DIAMONDS = 'UPDATE_DIAMONDS';

// DATE
export const UPDATE_STATE_DATE_FINDER_SUCCESS = 'UPDATE_STATE_DATE_FINDER_SUCCESS';
export const GET_LIST_DATE_FINDER_SUCCESS = 'GET_LIST_DATE_FINDER_SUCCESS';
export const POST_FILTER_DATE_FINDER_SUCCESS = 'POST_FILTER_DATE_FINDER_SUCCESS';
export const POST_CREATE_DATE_FINDER_SUCCESS = 'POST_CREATE_DATE_FINDER_SUCCESS';
export const GET_MY_DATE_FINDER_SUCCESS = 'GET_MY_DATE_FINDER_SUCCESS';
export const GET_DETAIL_DATE_FINDER_SUCCESS = 'GET_DETAIL_DATE_FINDER_SUCCESS';
export const DELETE_MY_DATE_FINDER_SUCCESS = 'DELETE_MY_DATE_FINDER_SUCCESS';
export const GET_DATE_FINDER_INTERESTS_SUCCESS = 'GET_DATE_FINDER_INTERESTS_SUCCESS';
export const PATCH_DATE_FINDER_INTEREST_SUCCESS = 'PATCH_DATE_FINDER_INTEREST_SUCCESS';
export const PATCH_DATE_FINDER_UN_INTEREST_SUCCESS = 'PATCH_DATE_FINDER_UN_INTEREST_SUCCESS';
export const UPDATE_MEMBER_TYPE_STATE_DATE_FINDER = 'UPDATE_MEMBER_TYPE_STATE_DATE_FINDER';
export const DATE_FINDER_SEARCH = 'DATE_FINDER_SEARCH';
export const ADD_DATE_FINDER_DESCRIPTIONS_SUCCESS = 'ADD_DATE_FINDER_DESCRIPTIONS_SUCCESS';
export const ADD_DATE_FINDER_MEETING_TYPES_SUCCESS = 'ADD_DATE_FINDER_MEETING_TYPES_SUCCESS';
export const DATE_FINDER_SUGGESTED = 'DATE_FINDER_SUGGESTED';
export const GET_MORE_DATE_FINDER_SUCCESS = 'GET_MORE_DATE_FINDER_SUCCESS';
export const DATE_FINDER_BLOCK_USER_SUCCESS = 'DATE_FINDER_BLOCK_USER_SUCCESS';
export const HANDLE_DATE_FINDER_MEETING_TYPES = 'HANDLE_DATE_FINDER_MEETING_TYPES';
export const UPDATE_MEMBER_TYPE_STATE_ADD_DATE_FINDER = 'UPDATE_MEMBER_TYPE_STATE_ADD_DATE_FINDER';
export const UPDATE_QUICK_SELECT_DATE_DATE_FINDER = 'UPDATE_QUICK_SELECT_DATE_DATE_FINDER';
export const UPDATE_QUICK_SELECT_LOCATION_DATE_FINDER = 'UPDATE_QUICK_SELECT_LOCATION_DATE_FINDER';
export const TOGGLE_ADD_DATE_MODAL = 'TOGGLE_ADD_DATE_MODAL';
export const UPDATE_HAS_CHANGE_FILTERS_STATUS = 'UPDATE_HAS_CHANGE_FILTERS_STATUS';
export const UPDATE_SEARCH_DATE_FINDER_STATUS = 'UPDATE_SEARCH_DATE_FINDER_STATUS';
export const EDIT_MY_DATE_SUCCESS = 'EDIT_MY_DATE_SUCCESS';
// Travel
export const UPDATE_STATE_TRAVEL_PLAN_SUCCESS = 'UPDATE_STATE_TRAVEL_PLAN_SUCCESS';
export const POST_CREATE_TRAVEL_PLAN_SUCCESS = 'POST_CREATE_TRAVEL_PLAN_SUCCESS';
export const PATCH_UPDATE_TRAVEL_PLAN_SUCCESS = 'PATCH_UPDATE_TRAVEL_PLAN_SUCCESS';
export const GET_MY_TRAVEL_PLAN_SUCCESS = 'GET_MY_TRAVEL_PLAN_SUCCESS';
export const GET_MY_TRAVEL_PLAN_FAILED = 'GET_MY_TRAVEL_PLAN_FAILED';
export const DELETE_MY_TRAVEL_PLAN_SUCCESS = 'DELETE_MY_TRAVEL_PLAN_SUCCESS';
export const GET_DETAIL_TRAVEL_PLAN_SUCCESS = 'GET_DETAIL_TRAVEL_PLAN_SUCCESS';
export const GET_USER_TRAVEL_SUCCESS = 'GET_USER_TRAVEL_SUCCESS';
export const UPDATE_MEMBER_TYPE_STATE_TRAVEL_PLAN = 'UPDATE_MEMBER_TYPE_STATE_TRAVEL_PLAN';
export const SEARCH_TRAVEL_SUCCESS = 'SEARCH_TRAVEL_SUCCESS';
export const TOGGLE_SINGLE_DATE_MODAL = 'TOGGLE_SINGLE_DATE_MODAL';
export const TOGGLE_SINGLE_DATE_CUSTOME_MODAL = 'TOGGLE_SINGLE_DATE_CUSTOME_MODAL';
export const SET_QUICK_DATE_SUCCESS = 'SET_QUICK_DATE_SUCCESS';
export const TOGGLE_MY_DATE_MODAL = 'TOGGLE_MY_DATE_MODAL';
export const TOGGLE_GREAT_IDEAL = 'TOGGLE_GREAT_IDEAL';
export const GET_TRAVEL_PLAN_EVENTS_SUCCESS = 'GET_TRAVEL_PLAN_EVENTS_SUCCESS';
export const SHOW_ADD_EDIT_TRAVEL_PLAN_MODAL = 'SHOW_ADD_EDIT_TRAVEL_PLAN_MODAL';
export const HIDE_ADD_EDIT_TRAVEL_PLAN_MODAL = 'HIDE_ADD_EDIT_TRAVEL_PLAN_MODAL';
export const TOGGLE_MY_TRAVEL_PLAN_MODAL = 'TOGGLE_MY_TRAVEL_PLAN_MODAL';
export const UPDATE_TRAVEL_PLAN_NEAR_YOU = 'UPDATE_TRAVEL_PLAN_NEAR_YOU';
export const CREATE_EVENT_INTEREST_TRAVEL = 'CREATE_EVENT_INTEREST_TRAVEL';
export const DELETE_INTEREST_TRAVEL = 'DELETE_INTEREST_TRAVEL';
// UPDATE_LIKE_OR_FAVORITE_MUTAL
export const UPDATE_LIKE_OR_FAVORITE_MUTAL = 'UPDATE_LIKE_OR_FAVORITE_MUTAL';
// FORUM

export const UPDATE_STATE_FORUM_STATE = 'UPDATE_STATE_FORUM_STATE';
export const TOGGLE_REGIONAL_FORUM_LOCATION = 'TOGGLE_REGIONAL_FORUM_LOCATION';
export const GET_BOARD_DATA_SUCCESS = 'GET_BOARD_DATA_SUCCESS';
export const GET_BOARD_DATA_SUMMARY_SUCCESS = 'GET_BOARD_DATA_SUMMARY_SUCCESS';
export const GET_TRENDING_FORUM_SUCCESS = 'GET_TRENDING_FORUM_SUCCESS';
export const GET_NEWEST_FORUM_SUCCESS = 'GET_NEWEST_FORUM_SUCCESS';
export const UPDATE_TRENDING_TOPIC_STATE = 'UPDATE_TRENDING_TOPIC_STATE';
export const UPDATE_NEWEST_TOPIC_STATE = 'UPDATE_NEWEST_TOPIC_STATE';
export const GET_FOLLOWING_TOPIC_SUCCESS = 'GET_FOLLOWING_TOPIC_SUCCESS';
export const GET_FOLLOWING_TOPIC_DESKTOP_SUCCESS = 'GET_FOLLOWING_TOPIC_DESKTOP_SUCCESS';
export const GET_MY_TOPIC_SUCCESS = 'GET_MY_TOPIC_SUCCESS';
export const GET_MY_TOPIC_DESKTOP_SUCCESS = 'GET_MY_TOPIC_DESKTOP_SUCCESS';
export const UPDATE_FOLLOWING_TOPIC_STATE = 'UPDATE_FOLLOWING_TOPIC_STATE';
export const UPDATE_MY_TOPIC_STATE = 'UPDATE_MY_TOPIC_STATE';
export const GET_SUB_FORUM_SUCCESS = 'GET_SUB_FORUM_SUCCESS';
export const GET_FORUM_TOPIC_SUCCESS = 'GET_FORUM_TOPIC_SUCCESS';
export const GET_SUB_FORUM_TOPIC_SUCCESS = 'GET_SUB_FORUM_TOPIC_SUCCESS';
export const GET_SUB_TOPIC_MORE_MESSAGE_SUCCESS = 'GET_SUB_TOPIC_MORE_MESSAGE_SUCCESS';
export const POST_CREATE_FORUM_TOPIC_LIKE_SUCCESS = 'POST_CREATE_FORUM_TOPIC_LIKE_SUCCESS';
export const POST_CREATE_FORUM_TOPIC_UNLIKE_SUCCESS = 'POST_CREATE_FORUM_TOPIC_UNLIKE_SUCCESS';
export const UPDATE_SUB_TOPIC_STATE = 'UPDATE_SUB_TOPIC_STATE';
export const UPDATE_FORUM_TOPIC_STATE = 'UPDATE_FORUM_TOPIC_STATE';
export const UPDATE_SEARCH_RESULT_BY_TAGS_STATE = 'UPDATE_SEARCH_RESULT_BY_TAGS_STATE';
export const GET_SEARCH_RESULT_BY_TAGS_SUCCESS = 'GET_SEARCH_RESULT_BY_TAGS_SUCCESS';
export const GET_SEARCH_FORUM_BY_TAGS_SUCCESS = 'GET_SEARCH_FORUM_BY_TAGS_SUCCESS';
export const POST_CREATE_TOPIC_FOLLOWING_SUCCESS = 'POST_CREATE_TOPIC_FOLLOWING_SUCCESS';
export const POST_CREATE_TOPIC_UN_FOLLOW_SUCCESS = 'POST_CREATE_TOPIC_UN_FOLLOW_SUCCESS';
export const DELETE_TOPIC = 'DELETE_TOPIC';
export const POST_CREATE_TOPIC_MESSAGE_LIKE_SUCCESS = 'POST_CREATE_TOPIC_MESSAGE_LIKE_SUCCESS';
export const POST_CREATE_TOPIC_MESSAGE_UNLIKE_SUCCESS = 'POST_CREATE_TOPIC_MESSAGE_UNLIKE_SUCCESS';
export const GET_TOPIC_MESSAGE_COMMENT_SUCCESS = 'GET_TOPIC_MESSAGE_COMMENT_SUCCESS';
export const POST_CREATE_TOPIC_MESSAGE_REPLY_SUCCESS = 'POST_CREATE_TOPIC_MESSAGE_REPLY_SUCCESS';
export const POST_CREATE_TOPIC_MESSAGE_SUCCESS = 'POST_CREATE_TOPIC_MESSAGE_SUCCESS';
export const DELETE_TOPIC_MESSAGE_SUCCESS = 'DELETE_TOPIC_MESSAGE_SUCCESS';
// Community
export const UPDATE_COMMUNITY_STORY_ID_SELECTED = 'UPDATE_COMMUNITY_STORY_ID_SELECTED';
export const UPDATE_COMMUNITY_STATE = 'UPDATE_COMMUNITY_STATE';
export const GET_ARTICLE_CATEGORIES_COUNT_SUMMARY = 'GET_ARTICLE_CATEGORIES_COUNT_SUMMARY';
export const GET_QUESTION_AND_ANSWER_CATEGORIES_COUNT_SUMMARY = 'GET_QUESTION_AND_ANSWER_CATEGORIES_COUNT_SUMMARY';
export const GET_STORY_CATEGORIES_COUNT_SUMMARY = 'GET_STORY_CATEGORIES_COUNT_SUMMARY';
export const GET_ARTICLES = 'GET_ARTICLE';
export const GET_QUESTION_AND_ANSWER = 'GET_QUESTION_AND_ANSWER';
export const GET_STORIES = 'GET_STORIES';
export const GET_MY_STORIES = 'GET_MY_STORIES';
export const DELETE_STORIES = 'DELETE_STORIES';
export const GET_OTG_LIST = 'GET_OTG_LIST';
export const GET_TESTIMONIAL = 'GET_TESTIMONIAL';
export const GET_COMMUNITY_DETAILS = 'GET_COMMUNITY_DETAILS';
export const GET_COMMUNITY_COMMENTS = 'GET_COMMUNITY_COMMENTS';
export const UPDATE_LOADING_STATE = 'UPDATE_LOADING_STATE';
export const DELETE_OTG_GALLERY_LIKE = 'DELETE_OTG_GALLERY_LIKE';
export const UPDATE_COMMUNITY_DETAIL_COMMENT_FAILED = 'UPDATE_COMMUNITY_DETAIL_COMMENT_FAILED';
export const GET_REPLY_SUCCESS = 'GET_REPLY_SUCCESS';
export const GET_OTG_PHOTO_REPLY_SUCCESS = 'GET_OTG_PHOTO_REPLY_SUCCESS';
export const POST_CREATE_LIKE_COMMUNITY_SUCCESS = 'POST_CREATE_LIKE_COMMUNITY_SUCCESS';
export const POST_CREATE_UN_LIKE_COMMUNITY_SUCCESS = 'POST_CREATE_UN_LIKE_COMMUNITY_SUCCESS';
export const GET_REPLY_SHOW_MORE_SHOW_LESS = 'GET_REPLY_SHOW_MORE_SHOW_LESS';
export const POST_CREATE_COMMUNITY_COMMENT_LIKE_SUCCESS = 'POST_CREATE_COMMUNITY_COMMENT_LIKE_SUCCESS';
export const POST_CREATE_OTG_PHOTO_COMMENT_LIKE_SUCCESS = 'POST_CREATE_OTG_PHOTO_COMMENT_LIKE_SUCCESS';
export const DELETE_COMMUNITY_COMMENT_LIKE_SUCCESS = 'DELETE_COMMUNITY_COMMENT_LIKE_SUCCESS';
export const DELETE_OTG_PHOTO_COMMENT_LIKE_SUCCESS = 'DELETE_OTG_PHOTO_COMMENT_LIKE_SUCCESS';
export const GET_OTG_PHOTOS = 'GET_OTG_PHOTOS';
export const GET_OTG_PHOTOS_COMMENTS = 'GET_OTG_PHOTOS_COMMENTS';
export const GET_OTG_PHOTOS_LIKE = 'GET_OTG_PHOTOS_LIKE';
export const POST_COMMENT_OTG_PHOTO_SUCCESS = 'POST_COMMENT_OTG_PHOTO_SUCCESS';
export const DELETE_OTG_PHOTO_COMMENT_SUCCESS = 'DELETE_OTG_PHOTO_COMMENT_SUCCESS';
export const POST_COMMENT_COMMUNITY_SUCCESS = 'POST_COMMENT_COMMUNITY_SUCCESS';
export const LOADING_COMMUNITY_DETAILS = 'LOADING_COMMUNITY_DETAILS';
export const DELETE_COMMUNITY_COMMENT_SUCCESS = 'DELETE_COMMUNITY_COMMENT_SUCCESS';
export const LOADING_OTG_PHOTO_DETAILS = 'LOADING_OTG_PHOTO_DETAILS';
export const TOPIC_LIKE_USER = 'TOPIC_LIKE_USER';
export const GET_COMMUNITY_LIKE_USER_SUCCESS = 'GET_COMMUNITY_LIKE_USER_SUCCESS';
export const GET_COMMUNITY_LIKE_USER_FAILED = 'GET_COMMUNITY_LIKE_USER_FAILED';
export const UPDATE_SHOW_SUPPORT_TICKET = 'UPDATE_SHOW_SUPPORT_TICKET';
export const APP_IN_BACKGROUND_TIME = 'APP_IN_BACKGROUND_TIME';
export const UPDATE_TOPIC_LIKE_USER = 'UPDATE_TOPIC_LIKE_USER';
export const GET_STORY_AUTH_DETAIL = 'GET_STORY_AUTH_DETAIL';
// SUPPORT TICKET
export const GET_SUPPORT_TICKET_NEW_COUNT = 'GET_SUPPORT_TICKET_NEW_COUNT';
export const GET_LIST_SUPPORT_TICKET_REQUEST = 'GET_LIST_SUPPORT_TICKET_REQUEST';
export const GET_LIST_SUPPORT_TICKET_SUCCESS = 'GET_LIST_SUPPORT_TICKET_SUCCESS';
export const GET_LIST_SUPPORT_TICKET_FAILED = 'GET_LIST_SUPPORT_TICKET_FAILED';
export const GET_CATEGORY_CONTACT_SUCCESS = 'GET_CATEGORY_CONTACT_SUCCESS';
export const GET_DETAIL_SUPPORT_TICKET_REQUEST = 'GET_DETAIL_SUPPORT_TICKET_REQUEST';
export const GET_DETAIL_SUPPORT_TICKET_SUCCESS = 'GET_DETAIL_SUPPORT_TICKET_SUCCESS';
export const GET_DETAIL_SUPPORT_TICKET_FAILED = 'GET_DETAIL_SUPPORT_TICKET_FAILED';
export const RESET_DETAIL_SUPPORT_TICKET_SUCCESS = 'RESET_DETAIL_SUPPORT_TICKET_SUCCESS';
export const UPDATE_LAST_MESSAGE_SELECTED_SUPPORT_TICKET_SUCCESS = 'UPDATE_LAST_MESSAGE_SELECTED_SUPPORT_TICKET_SUCCESS';
export const SHOW_LIST_SUPPORT_TICKET_MODAL = 'SHOW_LIST_SUPPORT_TICKET_MODAL';
export const HIDE_LIST_SUPPORT_TICKET_MODAL = 'HIDE_LIST_SUPPORT_TICKET_MODAL';
export const UPDATE_REF_TICKET_DETAIL = 'UPDATE_REF_TICKET_DETAIL';
export const UPDATE_VIEWING_USER_ID = 'UPDATE_VIEWING_USER_ID';
export const MODAL_AUTHENTICATE = 'MODAL_AUTHENTICATE';
export const SELECT_PREVIEW_PHOTO = 'SELECT_PREVIEW_PHOTO';
export const GET_PROFILE_ACTIVITY_SUCCESS = 'GET_PROFILE_ACTIVITY_SUCCESS';
export const GET_PROFILE_GROUPS_SUCCESS = 'GET_PROFILE_GROUPS_SUCCESS';
export const ACTION_TYPE = {
  LIKE: 'Like',
  UN_LIKE: 'Unlike',
} as const;
export type ActionSubType = (typeof ACTION_TYPE)[keyof typeof ACTION_TYPE];
export const TOGGLE_RECENTLY_SENT_PHOTO = 'TOGGLE_RECENTLY_SENT_PHOTO';
export const TOGGLE_SET_MESSAGE_IMAGE_DURATION_MODAL = 'TOGGLE_SET_MESSAGE_IMAGE_DURATION_MODAL';
export const SET_TIME_DURATION_SELECTION_VALUE = 'SET_TIME_DURATION_SELECTION_VALUE';
export const GET_USER_SHARED_PHOTOS_SUCCESS = 'GET_USER_SHARED_PHOTOS_SUCCESS';
export const ADD_USER_MEDIA_SUCCESS = 'ADD_USER_MEDIA_SUCCESS';
export const PATCH_USER_SHARED_PHOTOS_SUCCESS = 'PATCH_USER_SHARED_PHOTOS_SUCCESS';
export const PATCH_USER_SHARED_VIDEOS_SUCCESS = 'PATCH_USER_SHARED_VIDEOS_SUCCESS';
export const ADD_PRODUCT_TO_STORE_REQUEST = 'ADD_PRODUCT_TO_STORE_REQUEST';
export const ADD_PRODUCT_TO_STORE_FAILED = 'ADD_PRODUCT_TO_STORE_FAILED';
export const ADD_PRODUCT_TO_STORE_SUCCESS = 'ADD_PRODUCT_TO_STORE_SUCCESS';

export const GET_USER_CURRENT_STORE_ORDER_REQUEST = 'GET_USER_CURRENT_STORE_ORDER_REQUEST';
export const GET_USER_CURRENT_STORE_ORDER_FAILED = 'GET_USER_CURRENT_STORE_ORDER_FAILED';
export const GET_USER_CURRENT_STORE_ORDER_SUCCESS = 'GET_USER_CURRENT_STORE_ORDER_SUCCESS';

export const TOGGLE_CART_VIEW_SUCCESS = 'TOGGLE_CART_VIEW_SUCCESS';
export const SELECT_PRODUCT_ITEM_SUCCESS = 'SELECT_PRODUCT_ITEM_SUCCESS';

export const GET_STORE_PRODUCT_IMAGE_REQUEST = 'GET_STORE_PRODUCT_IMAGE_REQUEST';
export const GET_STORE_PRODUCT_IMAGE_FAILED = 'GET_STORE_PRODUCT_IMAGE_FAILED';
export const GET_STORE_PRODUCT_IMAGE_SUCCESS = 'GET_STORE_PRODUCT_IMAGE_SUCCESS';

export const GET_STORE_PRODUCTS_REQUEST = 'GET_STORE_PRODUCTS_REQUEST';
export const GET_STORE_PRODUCTS_FAILED = 'GET_STORE_PRODUCTS_FAILED';
export const GET_STORE_PRODUCTS_SUCCESS = 'GET_STORE_PRODUCTS_SUCCESS';
export const UPDATE_STATE_RHP_STORE = 'UPDATE_STATE_RHP_STORE';
export const UPDATE_STATE_RHP_STORE_WITH_KEY = 'UPDATE_STATE_RHP_STORE_WITH_KEY';
export const UPDATE_STORE_PRODUCT_CATEGORY = 'UPDATE_STORE_PRODUCT_CATEGORY';

export const GET_USER_STORE_CREDITS_SUCCESS = 'GET_USER_STORE_CREDITS_SUCCESS';

export const GET_USER_ORDER_DETAIL_SUCCESS = 'GET_USER_ORDER_DETAIL_SUCCESS';

export const GET_CLUB_EVT_SUCCESS = 'GET_CLUB_EVT_SUCCESS';
export const GET_CLUB_PAST_EVT_SUCCESS = 'GET_CLUB_PAST_EVT_SUCCESS';
export const DELETE_CLUB_COMMENT_SUCCESS = 'DELETE_CLUB_COMMENT_SUCCESS';
export const POST_CREATE_UPDATE_VOTE_SUCCESS = 'POST_CREATE_UPDATE_VOTE_SUCCESS';
export const UPDATE_STATE_EVENT_DETAIL = 'UPDATE_STATE_EVENT_DETAIL';
export const UPDATE_USER_PHOTO_GROUP_CHAT = 'UPDATE_USER_PHOTO_GROUP_CHAT';
export const END_GROUP_CHAT_SUCCESS = 'END_GROUP_CHAT_SUCCESS';
export const UPDATE_STATE_GROUP_CHAT = 'UPDATE_STATE_GROUP_CHAT';
export const DELETE_EVENT_INTEREST_BY_OWNER_SUCCESS = 'DELETE_EVENT_INTEREST_BY_OWNER_SUCCESS';
export const MERGE_FILTER_INTERESTED = 'MERGE_FILTER_INTERESTED';

export const UPDATE_METRICS_STATUS = 'UPDATE_METRICS_STATUS';
export const UPDATE_WINDOW_DIMENSIONS = 'UPDATE_WINDOW_DIMENSIONS';
export const TOGGLE_OPTION_DATE_FINDER_EVENT = 'UPDATE_TOGGLE_OPTION_DATE_EVENT';
export const UPDATE_CHAT_SYSTEM_DOWN_MODAL_STATUS = 'UPDATE_CHAT_SYSTEM_DOWN_MODAL_STATUS';
// Recently validated
export const UPDATE_MEMBER_TYPE_STATE_VALIDATED = 'UPDATE_MEMBER_TYPE_STATE_VALIDATED';
export const UPDATE_STATE_VALIDATED_SUCCESS = 'UPDATE_STATE_VALIDATED_SUCCESS';
export const UPDATE_RECENTLY_VALIDATION_STATUS = 'UPDATE_RECENTLY_VALIDATION_STATUS';
export const GET_RECENTLY_VALIDATION_DATA_SUCCESS = 'GET_RECENTLY_VALIDATION_DATA_SUCCESS';

// SHARED MEDIA EVENT TYPES
export const GET_SHARED_MEDIA_REQUEST = 'GET_SHARED_MEDIA_REQUEST';
export const GET_SHARED_MEDIA_SUCCESS = 'GET_SHARED_MEDIA_SUCCESS';
export const GET_SHARED_MEDIA_FAILED = 'GET_SHARED_MEDIA_FAILED';
export const DELETE_SHARED_MEDIA_SUCCESS = 'DELETE_SHARED_MEDIA_SUCCESS';
// GroupChat Get Group can be invited
export const LOADING_GROUP_CHAT_CAN_BE_INVITE = 'LOADING_GROUP_CHAT_CAN_BE_INVITE';
export const GET_GROUP_CHAT_CAN_BE_INVITE_SUCCESS = 'GET_GROUP_CHAT_CAN_BE_INVITE_SUCCESS';
export const ADD_GROUP_SHOULD_SEND_JOIN_MESSAGE = 'ADD_GROUP_SHOULD_SEND_JOIN_MESSAGE';
export const REMOVE_GROUP_SHOULD_SEND_JOIN_MESSAGE = 'REMOVE_GROUP_SHOULD_SEND_JOIN_MESSAGE';
export const ADD_ROOMJID_SHOULD_SEND_JOIN_MESSAGE = 'ADD_ROOMJID_SHOULD_SEND_JOIN_MESSAGE';
export const ADD_ROOMJID_SENDING_JOIN_MESSAGE = 'ADD_ROOMJID_SENDING_JOIN_MESSAGE';
export const TOGGLE_CLOSE_LIVE_STREAM = 'TOGGLE_CLOSE_LIVE_STREAM';
export const REMOVE_ROOMJID_SHOULD_SEND_JOIN_MESSAGE = 'REMOVE_ROOMJID_SHOULD_SEND_JOIN_MESSAGE';
export const UPDATE_GROUP_CHAT_MESSAGE_STATUS = 'UPDATE_GROUP_CHAT_MESSAGE_STATUS';
export const UPDATE_FEATURE_ROOMS_DATA = 'UPDATE_FEATURE_ROOMS_DATA';
export const UPDATE_FEATURE_ROOM_DATA = 'UPDATE_FEATURE_ROOM_DATA';
export const UPDATE_SELECTED_GROUP_DATA = 'UPDATE_SELECTED_GROUP_DATA';
// Consumable Purchase
export const UPDATE_PROFILE_BOOST_PRODUCTS = 'UPDATE_PROFILE_BOOST_PRODUCTS';
export const UPDATE_CONVERSATION_BOOST_PRODUCTS = 'UPDATE_CONVERSATION_BOOST_PRODUCTS';
export const UPDATE_GENDER_TYPE_CHANGE_PRODUCTS = 'UPDATE_GENDER_TYPE_CHANGE_PRODUCTS';
export const UPDATE_LIKE_PRODUCTS = 'UPDATE_LIKE_PRODUCTS';
export const UPDATE_FAV_PRODUCTS = 'UPDATE_FAV_PRODUCTS';
export const UPDATE_USER_REMAINING_INVITES_CREDIT = 'UPDATE_USER_REMAINING_INVITES_CREDIT';
export const UPDATE_INVITES_CREDIT_PRODUCTS = 'UPDATE_INVITES_CREDIT_PRODUCTS';
//Get location
export const GET_LOCATION = 'GET_LOCATION';

export const UPDATE_DATA_SPOTLIGHT_SUCCESS = 'UPDATE_DATA_SPOTLIGHT_SUCCESS';

export const UPDATE_OPTIONS_PROFILE_SUMMARY_SUCCESS = 'UPDATE_OPTIONS_PROFILE_SUMMARY_SUCCESS';

//GROUP
export const GET_GROUP_POPULAR_SEARCH_SUCCESS = 'GET_GROUP_POPULAR_SEARCH_SUCCESS';
export const GET_GROUP_DESKTOP_POPULAR_SEARCH_SUCCESS = 'GET_GROUP_DESKTOP_POPULAR_SEARCH_SUCCESS';
export const GET_GROUP_DETAIL_SUCCESS = 'GET_GROUP_DETAIL_SUCCESS';
export const GET_GROUP_VOTE_COMMENTS_SUCCESS = 'GET_GROUP_VOTE_COMMENTS_SUCCESS';
export const GET_GROUP_JOINED_USERS_SUCCESS = 'GET_GROUP_JOINED_USERS_SUCCESS';
export const GET_GROUP_EVENTS_SUCCESS = 'GET_GROUP_EVENTS_SUCCESS';
export const GET_GROUP_PHOTOS_SUCCESS = 'GET_GROUP_PHOTOS_SUCCESS';
export const GET_GROUP_VIDEOS_SUCCESS = 'GET_GROUP_VIDEOS_SUCCESS';
export const GET_GROUP_ALBUMS_SUCCESS = 'GET_GROUP_ALBUMS_SUCCESS';
export const GET_GROUP_ACTIVITY_SUCCESS = 'GET_GROUP_ACTIVITY_SUCCESS';
export const GET_GROUP_ALERT_SUCCESS = 'GET_GROUP_ALERT_SUCCESS';
export const REMOVE_GROUP_SUCCESS = 'REMOVE_GROUP_SUCCESS';
export const CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS';
export const UPDATE_GROUP_SUCCESS = 'UPDATE_GROUP_SUCCESS';
export const UPDATE_BANNER_GROUP_SUCCESS = 'UPDATE_BANNER_GROUP_SUCCESS';

export const TOGGLE_REMINDER_FEATURE_CHAT_ROOM_SUCCESS = 'TOGGLE_REMINDER_FEATURE_CHAT_ROOM_SUCCESS';

export const UPDATE_GROUP_EVENT_SUCCESS = 'UPDATE_GROUP_EVENT_SUCCESS';
export const GET_MY_GROUP_SUCCESS = 'GET_MY_GROUP_SUCCESS';
export const GET_JOINED_GROUP_SUCCESS = 'GET_JOINED_GROUP_SUCCESS';
export const MERGE_DATA_GROUP = 'MERGE_DATA_GROUP';
export const MERGE_DATA_EVENT = 'MERGE_DATA_EVENT';
export const UPDATE_DATA_GROUP = 'UPDATE_DATA_GROUP';
export const BLOCK_A_GROUP_SUCCESS = 'BLOCK_A_GROUP_SUCCESS';
export const JOIN_A_GROUP_SUCCESS = 'JOIN_A_GROUP_SUCCESS';
export const LEAVE_A_GROUP_SUCCESS = 'LEAVE_A_GROUP_SUCCESS';
export const POST_UPDATE_MEDIA_COMMENT_SUCCESS = 'POST_UPDATE_MEDIA_COMMENT_SUCCESS';
export const UPDATE_MEDIA_LIKE_SUCCESS = 'UPDATE_MEDIA_LIKE_SUCCESS';
export const POST_CREATE_POST_COMMENT_SUCCESS = 'POST_CREATE_POST_COMMENT_SUCCESS';
export const UPDATE_POST_LIKE_SUCCESS = 'UPDATE_POST_LIKE_SUCCESS';
export const GET_POST_COMMENT_SUCCESS = 'GET_POST_COMMENT_SUCCESS';
export const GET_POST_LIKE_USERS_SUCCESS = 'GET_POST_LIKE_USERS_SUCCESS';
export const GET_POST_DETAIL_SUCCESS = 'GET_POST_DETAIL_SUCCESS';
export const POST_DELETE_POST_COMMENT_SUCCESS = 'POST_DELETE_POST_COMMENT_SUCCESS';
export const GET_MORE_REPLIES_SUCCESS = 'GET_MORE_REPLIES_SUCCESS';
export const GET_MORE_ALBUM_REPLIES_SUCCESS = 'GET_MORE_ALBUM_REPLIES_SUCCESS';
export const UPDATE_POST_COMMENT_LIKE_SUCCESS = 'UPDATE_POST_COMMENT_LIKE_SUCCESS';
export const UPDATE_ALBUM_COMMENT_LIKE_SUCCESS = 'UPDATE_ALBUM_COMMENT_LIKE_SUCCESS';
export const DELETE_POST_SUCCESS = 'DELETE_POST_SUCCESS';
export const INIT_MEDIA_UPLOADING_STATE = 'INIT_MEDIA_UPLOADING_STATE';
export const UPDATE_MEDIA_UPLOADING_STATE = 'UPDATE_MEDIA_UPLOADING_STATE';
export const DELETE_ALBUM_SUCCESS = 'DELETE_ALBUM_SUCCESS';
export const GET_GROUP_CHATS_SUCCESS = 'GET_GROUP_CHATS_SUCCESS';
export const GET_ALBUM_DETAIL_SUCCESS = 'GET_ALBUM_DETAIL_SUCCESS';
export const RESET_POST_DETAIL_DATA_SUCCESS = 'RESET_POST_DETAIL_DATA_SUCCESS';
export const UPDATE_ALBUM_DETAIL_SUCCESS = 'UPDATE_ALBUM_DETAIL_SUCCESS';
export const UPDATE_POST_DETAIL_SUCCESS = 'UPDATE_POST_DETAIL_SUCCESS';
export const GET_CLUB_LIST_CAN_BE_INVITED_SUCCESS = 'GET_CLUB_LIST_CAN_BE_INVITED_SUCCESS';
export const GET_JOIN_USER_REQUEST_SUCCESS = 'GET_JOIN_USER_REQUEST_SUCCESS';
export const GET_RECOMMENDED_GROUP_SUCCESS = 'GET_RECOMMENDED_GROUP_SUCCESS';
export const GET_RECOMMENDED_GROUP_REQUEST = 'GET_RECOMMENDED_GROUP_REQUEST';
export const GET_RECOMMENDED_GROUP_FAILED = 'GET_RECOMMENDED_GROUP_FAILED';
export const UPDATE_GROUP_MEMBER_SUCCESS = 'UPDATE_GROUP_MEMBER_SUCCESS';
export const PATCH_CLUB_USER_BAN_POSTING_SUCCESS = 'PATCH_CLUB_USER_BAN_POSTING_SUCCESS';
export const PATCH_CLUB_USER_MEMBER_LEVEL_SUCCESS = 'PATCH_CLUB_USER_MEMBER_LEVEL_SUCCESS';
export const GET_ALBUM_COMMENT_SUCCESS = 'GET_ALBUM_COMMENT_SUCCESS';
export const DELETE_ALBUM_COMMENT_SUCCESS = 'DELETE_ALBUM_COMMENT_SUCCESS';
export const DELETE_CLUB_MEDIA_SUCCESS = 'DELETE_CLUB_MEDIA_SUCCESS';
export const MERGE_DATA_GROUP_NOTIFICATION = 'MERGE_DATA_GROUP_NOTIFICATION';
export const GET_GROUP_ACTIVITIES_NOTIFICATION_SUCCESS = 'GET_GROUP_ACTIVITIES_NOTIFICATION_SUCCESS';
export const GET_GROUP_JOIN_REQUEST_NOTIFICATION_SUCCESS = 'GET_GROUP_JOIN_REQUEST_NOTIFICATION_SUCCESS';
export const GET_GROUP_ALERTS_SUCCESS = 'GET_GROUP_ALERTS_SUCCESS';
export const GET_GROUP_SUGGESTED_USERS_SUCCESS = 'GET_GROUP_SUGGESTED_USERS_SUCCESS';
export const GET_EVENT_SUGGESTED_USERS_SUCCESS = 'GET_EVENT_SUGGESTED_USERS_SUCCESS';
export const GET_GROUP_SUGGESTED_USERS_REQUEST = 'GET_GROUP_SUGGESTED_USERS_REQUEST';
export const GET_EVENT_SUGGESTED_USERS_REQUEST = 'GET_EVENT_SUGGESTED_USERS_REQUEST';
export const GET_ALL_GROUP_ACTIVITY_SUCCESS = 'GET_ALL_GROUP_ACTIVITY_SUCCESS';
export const RESET_GROUP_ACTIVITY_SUCCESS = 'RESET_GROUP_ACTIVITY_SUCCESS';
export const GET_ALL_GROUP_ACTIVITY_REQUEST = 'GET_ALL_GROUP_ACTIVITY_REQUEST';
export const UPDATE_GROUP_SUGGESTED_USER_FILTER = 'UPDATE_GROUP_SUGGESTED_USER_FILTER';
export const RESET_GROUP_SUGGESTED_USER_FILTER = 'RESET_GROUP_SUGGESTED_USER_FILTER';
export const UPDATE_EVENT_SUGGESTED_USER_FILTER = 'UPDATE_EVENT_SUGGESTED_USER_FILTER';
export const RESET_EVENT_SUGGESTED_USER_FILTER = 'RESET_EVENT_SUGGESTED_USER_FILTER';
export const GET_INVITES_GROUP_RECEIVED_REQUEST = 'GET_INVITES_GROUP_RECEIVED_REQUEST';
export const GET_INVITES_GROUP_RECEIVED_FAILED = 'GET_INVITES_GROUP_RECEIVED_FAILED';
export const GET_INVITES_GROUP_RECEIVED_SUCCESS = 'GET_INVITES_GROUP_RECEIVED_SUCCESS';
export const DELETE_INVITES_GROUP_RECEIVED_SUCCESS = 'DELETE_INVITES_GROUP_RECEIVED_SUCCESS';
export const UPDATE_GROUP_ACTIVITY_LOADING = 'UPDATE_GROUP_ACTIVITY_LOADING';
export const RESET_GROUP_INVITE_SUCCESS = 'RESET_GROUP_INVITE_SUCCESS';
export const GET_USER_CLUB_NEW_USERS = 'GET_USER_CLUB_NEW_USERS';

export const GET_USER_INVITE_SUCCESS = 'GET_USER_INVITE_SUCCESS';
export const TOGGLE_EVENT_INTEREST_SUCCESS = 'TOGGLE_EVENT_INTEREST_SUCCESS';
export const TOGGLE_EVENT_INTEREST_SUCCESS_GROUP_ACTIVITY = 'TOGGLE_EVENT_INTEREST_SUCCESS_GROUP_ACTIVITY';
export const GET_SUGGESTED_GROUP_SUCCESS = 'GET_SUGGESTED_GROUP_SUCCESS';
export const INIT_MEDIA_UPLOADING_STATE_REPORT = 'INIT_MEDIA_UPLOADING_STATE_REPORT';
export const RESET_MEDIA_UPLOADING_STATE_REPORT = 'RESET_MEDIA_UPLOADING_STATE_REPORT';
export const UPDATE_MEDIA_UPLOADING_STATE_REPORT = 'UPDATE_MEDIA_UPLOADING_STATE_REPORT';
export const UPGRADE_PERMISSION_GROUP_DETAIL = 'UPGRADE_PERMISSION_GROUP_DETAIL';

// Typed action constants object with literal types
export const ACTION_TYPES = {
  NOT_REDUCER,
  BEGIN_AJAX_CALL,
  AJAX_CALL_ERROR,
  LOAD_COURSES_SUCCESS,
  CREATE_COURSE_SUCCESS,
  UPDATE_COURSE_SUCCESS,
  UPDATE_USER_REGISTER_PROPERTY_STATE,
  MERGE_USER_REGISTER_PROPERTY_STATE,
  CALC_USER_REGISTER_PROPERTY_STATE,
  RESET_STATE_USER_REGISTER,
  LOAD_CONVERSATIONS_REQUEST,
  LOAD_CONVERSATIONS_SUCCESS,
  HIDDEN_STATEMENT_READ,
  HIDDEN_SAFETY_READ,
  LOAD_NEW_CONVERSATIONS_SUCCESS,
  UPDATE_DIFF_CONVERSATIONS_SUCCESS,
  UPDATE_SERVER_TIME_GROUP_CHAT_SUCCESS,
  LOAD_CONVERSATIONS_FAILURE,
  LOAD_MORE_CONVERSATIONS,
  RESET_CONVERSATIONS,
  LOAD_MORE_CONVERSATIONS_FAILURE,
  PATCH_RULES_GROUP_CHAT_SUCCESS,
  TOGGLE_AUTO_SELECT_CONVERSATION,
  UPDATE_USERS_ONLINE_STATUS,
  UPDATE_GROUP_CHAT_SHOULD_BE_SELECTED,
  REMOVE_ROOMJID_IN_JOINED_SUCCESS_ROOM_JIDS,
  CLEAR_JOINED_SUCCESS_ROOM_JID,
  UPDATE_JOINING_ROOM_JIDS,
  UPDATE_JOINED_ROOM_JIDS_FAILED,
  UPDATE_ROOM_JID_BEING_JOINED,
  UPDATE_IS_ACTIVE_PRIVATE_ROOM_CONVERSATION,
  UPDATE_JOINED_PRIVATE_GROUP_CHAT,
  UPDATE_MESSAGE_ID_SELECTED,
  ADD_DATA_TO_SCHEDULE_REMOVE_CONVERSATION,
  CLEAR_DATA_TO_SCHEDULE_REMOVE_CONVERSATION,
  SEARCH_CONVERSATIONS_SUCCESS,
  SELECT_PEERVCARD_SUCCESS,
  SELECT_PEERVCARD_REQUEST,
  SELECT_PEERVCARD_FAILED,
  PIN_CONVERSATION_SUCCESS,
  UNPIN_CONVERSATION_SUCCESS,
  DELETE_CONVERSATION_SUCCESS,
  REPORT_CONVERSATION_SUCCESS,
  UPDATE_LOAD_STATUS,
  UPDATE_LASTTIME_SYNC,
  RESET_PAGE_NUMBER_CONVERSATIONS,
  UPDATE_CONVERSATION,
  UPDATE_MEMBER_COUNT,
  UPDATE_STATUS_CONVERSATION,
  UPDATE_CONVERSATION_SUCCESS,
  DELETE_CONVERSATION_LAST_MESSAGE_SUCCESS,
  HIDDEN_CONVERSATION_LAST_MESSAGE_SUCCESS,
  PATCH_IGNORE_CONVERSATION_SUCCESS,
  GET_CONVERSATION_DETAIL,
  UPDATE_MODAL_DELETE,
  UPDATE_LIST_CONVERSATION_IDS_DELETED,
  LOAD_CONVERSATION_DETAIL_SUCCESS,
  LOAD_CONVERSATION_DETAIL_FAILURE,
  LOAD_CONVERSATION_DETAIL_PENDING,
  LOAD_CONVERSATION_DETAIL_REQUEST,
  LOAD_CONVERSATION_DETAIL_REQUEST_SUCCESS,
  LOAD_CONVERSATIONS_DETAIL_FAIL,
  GET_OR_CREATE_CONVERSATIONS_FAIL,
  RESET_GET_OR_CREATE_ERROR,
  RESET_CONVERSATION_UNREAD_COUNT_SUCCESS,
  RESET_SELECTED_PEERVCARD_AND_CONVERSATION_INFO_SUCCESS,
  CHAT_UPDATE_MESSAGE_DELIVERED,
  CHAT_UPDATE_MESSAGE_READ,
  UPDATE_FILTER_CONVERSATIONS,
  GET_CONVERSATIONS_UNREAD_COUNT,
  UPDATE_LOADING_CONVERSATION_DETAIL,
  CREATE_CONVERSATION_SUCCESS,
  CREATE_CONVERSATION_FAILURE,
  CREATE_CONVERSATION_REQUEST,
  FILTER_CONVERSATIONS,
  UPDATE_FILTER_PARAMS_BY_DEFAULT_FOLDER,
  GET_PHOTOS_SUCCESS,
  GET_PHOTOS_DENIED,
  GET_CONVERSATION_STATUS_REQUEST,
  GET_CONVERSATION_STATUS_FAILURE,
  GET_CONVERSATION_STATUS,
  CHECK_PIN_STATUS_CONVERSATION_SELECTED,
  UPDATE_CONVERSATION_NAVIGATE_TYPE,
  LOAD_MAIN_AVATARS_SUCCESS,
  GET_MAIN_PHOTOS_REQUEST,
  GET_MAIN_PHOTO_REQUEST,
  GET_MAIN_PHOTOS_FAILED,
  GET_MAIN_PHOTOS_SUCCESS,
  RETRY_LOAD_CONVERSATIONS,
  SET_READ_CONVERSATION_REQUEST,
  SET_READ_CONVERSATION_SUCCESS,
  SET_READ_CONVERSATION_FAILURE,
  RETRYING_API_FAIL,
  RETRYING_API_FAIL_SUCCESS,
  UPDATE_CONVERSATION_UNREAD,
  UPDATE_MEMBER_LEVEL_CONVERSATION_SELECTED,
  UPDATE_PARTICIPANT_COUNT,
  SAVE_PEEVCARD,
  DELETE_MESSAGE_SUCCESS,
  DELETE_MESSAGE_FAIL,
  UPDATE_USER_GROUPCHAT_MESSAGE,
  TOGGLE_REPORT_POPUP,
  TOGGLE_NO_PHOTO_POPUP,
  TOGGLE_REPORT_POPUP_POST,
  TOGGLE_PROFILE_MODAL,
  LOAD_ICE_BREAKER_SUCCESS,
  LOAD_GIFTS_RECEIVED_SUCCESS,
  SELECT_GIFT_DATA,
  LOADING_GIFTS_DATA,
  LOAD_GIFTS_DATA,
  LOAD_GIFT_CATEGORIES_DATA,
  LOAD_GIFT_REPLIES_DATA,
  SELECT_QUICK_MESSAGE_SUCCESS,
  LOAD_QUICK_MESSAGE_REQUEST,
  LOAD_QUICK_MESSAGE_FAILED,
  LOAD_QUICK_MESSAGE_SUCCESS,
  ADD_QUICK_MESSAGE_SUCCESS,
  UPDATE_QUICK_MESSAGE_SUCCESS,
  DELETE_QUICK_MESSAGE_SUCCESS,
  ADD_GRANTED_ALBUM,
  GET_ALBUM_SUCCESS,
  UPDATE_GALLERY_ACCESS,
  GET_ALBUM_REQUEST,
  GET_ALBUM_FAILED,
  GRANT_ACCESS_SUCCESS,
  USER_REQUEST_LOGIN,
  USER_LOGIN_SUCCESS,
  UPDATE_LOGIN_REDUCER_STATE,
  USER_LOGIN_FAIL,
  UPDATE_CONNECTION_STATUS,
  ATTEMPT_CONNECT_SUCCESS,
  TOGGLE_DISABLE_RECONNECTING_LABEL,
  FIRST_CALL_API,
  GET_JIDRESOURCE_SUCCESS,
  UPDATE_RETAIN_STATUS_SUCCESS,
  UPDATE_LOGIN_STATE,
  UPDATE_SUB_MENU_SELECTED,
  UPDATE_STATE_USER_LOGIN,
  USER_LOGOUT_SUCCESS,
  USER_REQUEST_USER_LOGIN_INFO_SUCCESS,
  USER_UPDATE_INFO_SUCCESS,
  USER_UPDATE_JID,
  USER_REQUEST_REGISTER,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
  UPDATE_ERROR_STATUS_LOGIN,
  CONNECT_FACEBOOK_SUCCESS,
  UPDATE_STATUS_LOGIN_FB,
  CHAT_UPDATE_LAST_MESSAGE_CONVERSATION_READ,
  UPDATE_SELECT_PEER_C_CARD_STATUS,
  UPDATE_DELETE_REFERENCE_MESSAGES,
  CHAT_UPDATE_MESSAGE_STATUS,
  RESET_MESSAGE_TO_INIT_DATA,
  CHAT_UPDATE_MESSAGES_STATUS,
  CHAT_UPDATE_MESSAGE_FAIL,
  CHAT_REPLACE_MESSAGE_SUCCESS,
  CHAT_ADD_SEND_MESSAGE_SUCCESS,
  CHAT_ADD_RECEIVE_MESSAGE_SUCCESS,
  CHAT_SEND_MESSAGE_READ_SUCCESS,
  CHAT_DELETE_PEER_ALL_MESSAGES,
  CHAT_UPDATE_ALBUM_STATUS_SUCCESS,
  CHAT_REMOVE_ALBUM_STATUS_SUCCESS,
  REMOVE_MESSAGE_IN_QUEUE_TO_SEND,
  ADD_MESSAGE_TO_QUEUE_TO_SEND,
  UPDATE_MESSAGE_REDUCER,
  CHAT_UPDATE_MESSAGE_ERROR,
  CHAT_REMOVE_MESSAGE_ERROR,
  REMOVE_STATUS_ERROR_MESSAGE,
  UPDATE_DRAFT_MSG,
  REMOVE_MESSAGE_SUCCESS,
  CHAT_EDIT_TEXT_MESSAGE_SUCCESS,
  CHAT_EDIT_LAST_MESSAGE_CONVERSATION_SUCCESS,
  REMOVE_MESSAGE_BY_USER_ID_AND_ROOM_JID_SUCCESS,
  REMOVE_MESSAGE_BY_ROOM_JID_SUCCESS,
  MARK_EXPIRED_MESSAGE_INVITE_PRIVATE_GROUP_CHAT,
  EXPIRE_MESSAGE_SUCCESS,
  UPDATE_MESSAGE_SENT,
  UPDATE_CONVERSATION_LAST_MESSAGE_SUCCESS,
  SET_REQUEST_TYPE_CALL,
  UPDATE_REACTION_MESSAGE_SUCCESS,
  STORE_REACTION_MESSAGE_SUCCESS,
  UPDATE_PROFILE_PHOTO_MESSAGE,
  CHAT_UPDATE_CHAT_STATE,
  REMOVE_PUBLIC_GROUP_CHAT,
  CHAT_UPDATE_GROUP_SUCCESS,
  CHAT_UPDATE_ROOMS_DATA,
  SET_IS_SORT_LIVE_STREAM,
  CHAT_UPDATE_GROUP_FAIL,
  UPDATE_BANNER_FREE_CHAT,
  RESET_CLOSING_TIME_GROUP_CHAT,
  CHAT_UPDATE_GROUP_REQUEST,
  SET_PROFILE_NOTE_MEMBER_SUCCESS,
  JOIN_CHAT_ROOM_SUCCESS,
  SET_NEXT_CHAT_ROOM_SUCCESS,
  QUIT_CHAT_ROOM_SUCCESS,
  GET_ROOM_DETAIL_SUCCESS,
  GROUPCHAT_DELETE_ALL_MESSAGES,
  GET_ROOM_MEMBERS_DETAIL_REQUEST,
  GET_ROOM_MEMBERS_DETAIL,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER_STATUS_LOCAL_SUCCESS,
  GET_LIST_USERS_STATUS_SUCCESS,
  CREATE_GROUP_CHAT_SUCCESS,
  SET_WAITING_PROGRESS_GROUP_CHAT_SUCCESS,
  UPDATE_WHISPER_STATUS_REALTIME,
  UPDATE_CHAT_ROOM_AUTHORIZED_SUCCESS,
  BANNED_SUCCESS,
  UPDATE_AL_READY_LOGGED,
  CHAT_UPDATE_ROSTER_SUCCESS,
  CHAT_UPDATE_MY_ROSTER_SUCCESS,
  CHAT_ADD_SUBSCRIBE_SUCCESS,
  CHAT_REMOVE_SUBSCRIBE_SUCCESS,
  CHAT_UPDATE_BLACKLIST_SUCCESS,
  COMMON_FETCHING,
  COMMON_FETCHED,
  COMMON_UPDATE_TAB_BOTTOM_INDEX,
  COMMON_TRACKING_ROUTE,
  GET_FRIENDS_FAVORITES_REQUEST,
  GET_FRIENDS_FAVORITES_SUCCESS,
  GET_FRIENDS_FAVORITES_FAILURE,
  GET_FRIENDS_FAVORITES,
  UPDATE_TEMP_DISPLAY_DATA_FRIEND_AND_FAV_SUCCESS,
  UPDATE_TEMP_DATA_FRIEND_AND_FAV_TO_DISPLAY_SUCCESS,
  GET_PROFILE_SUCCESS,
  ADD_FAVORITE,
  REMOVE_FAVORITE,
  LOAD_MORE_FRIENDS_FAVORITES,
  BLOCK_USER,
  UPDATE_FILTER_FRIEND_AND_FAVORITE,
  LOAD_SCREEN_MESSAGES_INBOX,
  LOAD_SCREEN_INBOX_DETAIL,
  LOAD_SCREEN_GROUPS_CHAT,
  LOAD_SCREEN_GROUP_CHAT_DETAIL,
  ADD_USER_PROFILE_SUCCESS,
  GET_MATCHING_USERS_SUCCESS,
  ADD_MATCHING_USER_SUCCESS,
  CHECK_MATCHING_PROFILE_SUCCESS,
  LOAD_SCREEN_USER_LOGIN,
  GET_MAIN_PHOTO_SUCCESS,
  UPDATE_USERS_STATE_SUCCESS,
  USER_LOGIN_ACCOUNT_SUCCESS,
  GET_PROFILE_GROUP_CHAT_SUCCESS,
  GET_USERS_WHO_BLOCK_ME,
  GET_USERS_BLOCKED,
  LOAD_SCREEN_FACE_BOOK_ACTIVE,
  FACE_BOOK_REGISTER_SUCCESS,
  FACE_BOOK_LOGIN_SUCCESS,
  FACE_BOOK_GET_USER_INFO_SUCCESS,
  APPLE_LOGIN_SUCCESS,
  GOOGLE_LOGIN_SUCCESS,
  REGISTER_SUCCESS,
  LOAD_SCREEN_SPLASH,
  UPDATE_STATE_LOADING_GET_CURRENT_POSITION_SUCCESS,
  LOAD_SCREEN_LOCATION_SELECTOR,
  GET_DETAILS_PLACE_SUCCESS,
  UPDATE_CURRENT_LOCATION_SUCCESS,
  UPDATE_USER_DETAIL_LOCATION,
  LOAD_SCREEN_FOGOT_PASSWORD,
  LOAD_SCREEN_RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  REQUEST_FORGOT_PASSWORD_SUCCESS,
  UPDATE_BACK_SCREEN_SUCCESS,
  ADD_REGISTRATION_PROPERTY_STATE,
  LTM_LOAD_SCREEN,
  LTM_LOAD_SCREEN_SUCCESS,
  LTM_LOAD_LOOKING_FOR_SUCCESS,
  LTM_LOAD_AGE_RANGE_SUCCESS,
  LTM_LOAD_INTENTIONS_SUCCESS,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_INFO_BACK_SUCCESS,
  UPDATE_ACTION_CHANGE_CATEGORY_SUCCESS,
  LTM_CHANGE_CATEGORY_SUCCESS,
  MPB_CHANGE_CATEGORY_SUCCESS,
  LOAD_INTRODUCE_YOURSELF_SCREEN,
  LOAD_INTRODUCE_YOURSELF_SUCCESS,
  LOAD_PERSONALITY_DATA_SUCCESS,
  LOAD_LOOK_DATA_SUCCESS,
  LOAD_INTERESTS_DATA_SUCCESS,
  LOAD_MPB_LOOKING_FOR_DATA_SUCCESS,
  UPDATE_SELECTING_PROFILE_BUILDER_ITEM_SUCCESS,
  TU1_LOAD_SCREEN,
  TU1_LOAD_SEX_SUCCESS,
  TU1_LOAD_AGE_SUCCESS,
  TU1_LOAD_ETHNICITY_SUCCESS,
  TU1_LOAD_RELATION_SHIP_SUCCESS,
  UPDATE_MEMBER_TYPE_SUCCESS,
  TU1_UPDATE_AGE_SUCCESS,
  TU1_UPDATE_HEIGHT_SUCCESS,
  UPDATE_SELECTING_CATEGORY_SUCCESS,
  SELECT_PROPERTY_ITEM_SUCCESS,
  UPDATE_STATUS_LOAD_MORE_PROPERTY_ITEMS_SUCCESS,
  UPDATE_AGE_RANGE,
  UPDATE_INDEX_TAB,
  UPDATE_MEMBER_TYPE,
  LOAD_BODY_TYPES_DATA_SUCCESS,
  LOAD_HEIGHT_DATA_SUCCESS,
  LOAD_ORIENTATION_DATA_SUCCESS,
  UPDATE_SUB_TAB_SUCCESS,
  TU3_LOAD_GENERAL_SUCCESS,
  TU3_LOAD_SEXUAL_SIGNLE_SUCCESS,
  TU3_LOAD_SEXUAL_COUPLE_SUCCESS,
  TU3_LOAD_FETISH_SUCCESS,
  UPDATE_VALUE_SUCCESS,
  UPDATE_CAN_NEXT_CATEGORY_SUCCESS,
  PUSH_SCREEN_SUCCESS,
  POP_SCREEN_SUCCESS,
  RESET_SCREEN_SUCCESS,
  INIT_ROUTES_SUCCESS,
  UPDATE_APP_STATE_SUCCESS,
  RESET_SCREEN,
  MEMBER_SEARCH,
  GET_USERS_MEMBER_SEARCH_SUCCESS,
  GET_USERS_SPOTLIGHT_SUCCESS,
  POST_USERS_MEMBER_SEARCH_SUCCESS,
  POST_USERS_MEMBER_SEARCH_ACTION_SUCCESS,
  LOAD_MORE_USERS_MEMBER_SEARCH_SUCCESS,
  GET_NICHE_SEARCH_SUCCESS,
  GET_NICHE_SEARCH_FAIL,
  UPDATE_REFINE_MODAL_STATUS,
  LOAD_SCREEN_MEMBER_SEARCH,
  SET_IN_USER_MEMBER_SEARCH,
  API_ERROR_SEARCH,
  RESET_DISCOVERY_ERROR_STATUS,
  GET_USER_SAVED_SEARCHES_SUCCESS,
  GET_USER_SEARCH_SETTINGS_SUCCESS,
  GET_LIST_ENTITIES_SUCCESS,
  SHOW_ALERT_CONVERSATIONS_FILTER,
  GET_LIST_ENTITIES_FAIL,
  MS_LIST_INTENTION,
  MS_LIST_RELATIONSHIP_STATUS,
  MS_LIST_BODY_TYPE,
  MS_LIST_HEIGHT,
  MS_LIST_ETHNICITY,
  MS_SEXUAL_ORIENTATION,
  MS_SEXUAL_INTERESTS,
  UPDATE_STATE_MEMBER_SEARCH,
  UPDATE_SORT_ORDER_TYPE,
  MS_UPDATE_MEMBER_SEARCH,
  SET_STATE_ENTITIES_TAB_INDEX,
  RESET_FILTER_MEMBER_SEARCH,
  RESET_PREMIUM_FILTER,
  RESET_SEARCH_FILTER,
  RESET_SEARCH_SPOTLIGHT_FILTER,
  DELETE_USER_MEMBER,
  GET_MEMBER_PROFILE_SUCCESS,
  GET_MEMBER_PROFILE_VALIDATE_SUCCESS,
  GET_MEMBER_PROFILE_FRIENDS_SUCCESS,
  UPDATE_MEMBER_PROFILE_STATE,
  UPDATE_MEMBER_PROFILE_PROPERTY_STATE,
  GET_MEMBER_PROFILE_ENTITIES_SUCCESS,
  POST_USERS_MEMBER_PROFILE_ACTION_SUCCESS,
  GET_MEMBER_PROFILE_TIME_OUT,
  MS_UPDATE_MEMBER_VIEW_PROFILES,
  UPDATE_LIST_USERS_LIKED_SUCCESS,
  UPDATE_MEMBER_PROFILE_TRAVEL_PLAN_SUCCESS,
  UPDATE_USER_STATUS,
  SET_STATUS_USER_IN_LIVE_STREAM,
  SET_STATUS_USER_IN_VIDEO_CALL,
  UPDATE_USER_LOGIN_STATE,
  SELECT_COUNTRY_PHONE_CODE_SUCCESS,
  UNPAUSE_ACOUNT,
  POST_MEMBER_CREATE_VALIDATION_SUCCESS,
  POST_MEMBER_CREATE_FRIEND_SUCCESS,
  POST_MEMBER_CREATE_BLOCK_USER_SUCCESS,
  TEMP_DATA_CAROUSEL,
  UPDATE_MESSENGER_PERMISSION_REQUEST,
  UPDATE_MESSENGER_PERMISSION_FAILED,
  UPDATE_MESSENGER_PERMISSION_SUCCESS,
  UPDATE_CHATROOM_MESSENGER_PERMISSION_SUCCESS,
  HIDE_STATUS_BAR,
  SHOW_STATUS_BAR,
  UPDATE_WINDOW_CALL_TYPE,
  UPDATE_RECEIVING_CALL_TYPE,
  UPDATE_MUTED,
  UPDATE_CAMERA_MODE,
  UPDATE_MIC,
  UPDATE_VOICE_CALL,
  UPDATE_VOICE_CALL_PEER_USER,
  UPDATE_STARTER,
  UPDATE_STATE_CALL,
  CLEAN_UP_VIDEO_CALL,
  CALL_STATE_STARTED_BY,
  SET_LOCAL_STREAM_SUCCESS,
  SET_FRIEND_ID,
  SET_PEER_STREAM_SUCCESS,
  CHANGE_STATUS_INCOMINGCALL,
  END_CALL_SUCCESS,
  ACCEPT_CALL_SUCCESS,
  UPDATE_INTERRUPTID,
  UPDATE_LIST_VIDEO_DEVICES,
  GET_CALLER_SUCCESS,
  GET_REQUEST_SUCCESS,
  GET_CALL_SUCCESS,
  CALL_ACTION_SUCCESS,
  CHANGE_STATUS_VIDEO_CALL_WINDOW,
  UPDATE_VIDEO_CALL_STATE,
  VIDEO_CALL_MINIMIZE,
  VIDEO_CALL_FULLSCREEN,
  SWITCH_CARD_VIDEO_VIEW,
  SHOW_LOCAL_PHOTO_SUCCESS,
  SHOW_PEER_PHOTO_SUCCESS,
  SET_PEER_PHOTO_SUCCESS,
  COUNT_DOWN_OR_RESET_TIME_CALL,
  ADD_PEER_USER_CALL_INFO_SUCCESS,
  GET_USER_PROFILE_PROSPECTS_SUCCESS,
  GET_USER_PROFILE_PROSPECTS_ERROR,
  UPDATE_PROSPECTS,
  LOAD_MORE_USER_PROFILE_PROSPECTS_SUCCESS,
  UPDATE_MEMBERTYPE_STATE_LIST,
  GET_PROSPECTS_COUNT,
  GET_PROSPECTS_COUNT_ERROR,
  UPDATE_ALL_MEMBERTYPE_STATE_LIST,
  RESET_PROSPECTS_ERROR_STATUS,
  GET_STATE_COUNT_SUCCESS,
  PROSPECTS_TIME_LOAD_INIT_DATA,
  UPDATE_CHAT_SERVER_TIME,
  SHOW_REPORT_V2,
  HIDE_REPORT_V2,
  CLEAR_REPORT_V2_DATA,
  UPDATE_MESSAGE_NOTIFICATION_ERROR,
  UPDATE_UNAVAILABLE_MESSENGER,
  UPDATE_UNAVAILABLE_CHATROOM,
  TOGGLE_MY_GROUPS_MODAL,
  TOGGLE_JOINED_GROUPS_MODAL,
  TOGGLE_GROUP_MEMBER_MODAL,
  TOGGLE_GLOBAL_PREVIEW_MEDIA_MODAL,
  UPDATE_DATA_IN_APP_NOTIFICATION,
  SUPPORT_NOTIFICATION_MANAGER,
  SET_IS_DESKTOP,
  RESET_DATA_IN_APP_NOTIFICATION,
  TOGGLE_CREATE_PASSWORD_MODAL,
  TOGGLE_VERIFY_PASSWORD_MODAL,
  ADD_IN_APP_NOTIFICATION_TO_MANAGER,
  REMOVE_IN_APP_NOTIFICATION_FROM_MANAGER,
  TOGGLE_IN_APP_NOTIFICATION,
  DELETE_USER_PROFILE_VIEW_SUCCESS,
  DELETE_LIST_USER_PROFILE_VIEW_SUCCESS,
  DELETE_USER_LIKE_OR_MATCH_SUCCESS,
  DELETE_LIST_USER_LIKE_OR_MATCH_SUCCESS,
  SHOW_CONFIRM_MODAL,
  UPDATE_DATA_CONFIRM_MODAL,
  UPDATE_COMMON_STATE_REDUCER,
  SHOW_NOTIFICATION_PHOTO_LIKE_MODAL,
  HIDE_NOTIFICATION_PHOTO_LIKE_MODAL,
  SHOW_NOTIFICATION_USER_INTEREST_MODAL,
  HIDE_NOTIFICATION_USER_INTEREST_MODAL,
  UPDATE_STATE_COMMON_STATE,
  TOGGLE_NOTIFICATION_GROUP_JOIN_REQUEST,
  TOGGLE_NOTIFICATION_INVITATION,
  TOGGLE_NOTIFICATION_GROUP_ACTIVITY,
  TOGGLE_NOTIFICATION_GROUP_JOINS,
  TOGGLE_SENSITIVE_MODAL,
  TOGGLE_SHARE_URL_MODAL,
  UPDATE_ERROR_API,
  GET_ABOUT_RHP_REQUEST,
  GET_ABOUT_RHP_SUCCESS,
  GET_ABOUT_RHP_FAILED,
  GET_SEARCH_FRIEND_ONLINE_REQUEST,
  GET_SEARCH_FRIEND_ONLINE_SUCCESS,
  GET_SEARCH_FRIEND_ONLINE_FAILED,
  GET_SEARCH_FAVOURITES_ONLINE_REQUEST,
  GET_SEARCH_FAVOURITES_ONLINE_SUCCESS,
  GET_SEARCH_FAVOURITES_ONLINE_FAILED,
  GET_DATA_HOME_PAGE_SUCCESS,
  MERGE_DATA_HOME_PAGE_SUCCESS,
  GET_ACTIVITY_SUMARY_USERS_SUCCESS,
  GET_DATA_HOME_PAGE_ERROR,
  UPDATE_NEW_FEED_STATE,
  RESET_HOME_ERROR_STATUS,
  GET_RECENT_SUCCESS,
  GET_ANNOUNCEMENT_BANNER_SUCCESS,
  TOGGLE_TESTIMONIAL_MODAL,
  GET_LIST_LIVE_STREAM_SUCCESS,
  SET_LIST_CURRENT_LIVE_STREAM_SUCCESS,
  UPDATE_LIVE_MEMBER,
  ADD_NEW_LIVE_STREAM_SUCCESS,
  REMOVE_LIVE_STREAM_SUCCESS,
  GET_LIST_LIVE_STREAM_IN_ROOM_SUCCESS,
  ADD_VIEWER_VIEW_LIVE_STREAM,
  REMOVE_VIEWER_VIEW_LIVE_STREAM,
  GET_STREAM_DETAIL_SUCCESS,
  SELECT_STREAM_IN_ROOM_SUCCESS,
  SELECT_STREAM_PUBLISHER_IN_ROOM_SUCCESS,
  WATCH_LIVE_STREAM_SUCCESS,
  ADD_NEW_WATCHER_SUCCESS,
  REMOVE_WATCHER_SUCCESS,
  RESET_SELECTED_STREAM,
  RESET_LIVE_STREAM_IN_ROOM,
  CREATE_PUBLIC_LIVE_STREAM_SUCCESS,
  CREATE_PUBLIC_LIVE_STREAM_FAILURE,
  QUIT_PUBLIC_LIVE_STREAM_SUCCESS,
  SELECT_PUBLIC_LIVE_STREAM_SUCCESS,
  GET_PUBLIC_STREAM_DETAIL_SUCCESS,
  SHOW_ALERT_STOPPED_PUBLIC_STREAM_DETAIL_SUCCESS,
  SET_WAITING_PROGRESS_PUBLIC_LIVE_STREAM_SUCCESS,
  GET_ALERT_SUCCESS,
  GET_EVENT_USER_EXPRESS_INTEREST_SUCCESS,
  GET_ALERT_NOTIFICATION_SUCCESS,
  GET_VALIDATION_NOTIFICATION_SUCCESS,
  GET_GROUP_INVITATION_NOTIFICATION_SUCCESS,
  GET_EVENT_INVITATION_NOTIFICATION_SUCCESS,
  GET_PHOTO_LIKES_NOTIFICATION_SUCCESS,
  GET_FRIEND_NOTIFICATION_SUCCESS,
  GET_DATEFINDER_NOTIFICATION_SUCCESS,
  GET_DATEFINDER_INTEREST_SUCCESS,
  MERGE_DATA_NOTIFICATION_SUCCESS,
  PATCH_ACTION_NOTIFICATION_SUCCESS,
  PATCH_ACTION_INTEREST_SUCCESS,
  DELETE_USER_FRIENDS,
  DELETE_NOTIFICATION_ALERT,
  RESET_ALL_DATA,
  GET_GROUP_USER_ACTIVITIES_SUCCESS,
  GET_GROUP_JOIN_REQUEST_SUCCESS,
  GET_MEMBER_TYPE_PLURAL_REQUEST,
  GET_MEMBER_TYPE_PLURAL_FAILURE,
  GET_MEMBER_TYPE_PLURAL_SUCCESS,
  GET_COMMON_USER_SEARCH_SETTING_REQUEST,
  GET_COMMON_USER_SEARCH_SETTING_FAILURE,
  GET_COMMON_USER_SEARCH_SETTING_SUCCESS,
  GET_EVENT_SEARCH_SUCCESS,
  GET_EVENT_SEARCH_SPONSORED_SUCCESS,
  GET_EVENT_CATEGORY_SUCCESS,
  GET_CLUB_CATEGORY_SUCCESS,
  TOGGLE_CREATE_EDIT_EVENT_MODAL,
  TOGGLE_MY_EVENTS_MODAL,
  TOGGLE_INTERESTED_IN_EVENT_DESKTOP_MODAL,
  TOGGLE_INTERESTED_IN_USER_EVENT_DESKTOP_MODAL,
  GET_TIMEZONE_SUCCESS,
  POST_SHOW_HIDDEN_TICKET_LINK,
  POST_INVITE_REMOVE_GROUP_CHAT,
  DELETE_ALL_USER_EVENT_GROUP_CHAT,
  GET_EVENT_INTERESTED_SUCCESS,
  GET_USER_EVENT_SUCCESS,
  GET_SHARE_MY_EVENT_SUCCESS,
  GET_CLUB_EVENT_SUCCESS,
  GET_MY_USER_EVENT_SUCCESS,
  GET_USER_INTEREST_EVENT_SUCCESS,
  GET_EVENT_INTEREST_SUCCESS,
  DELETE_EVENT_INTEREST_SUCCESS,
  GET_EVENT_DETAIL_SUCCESS,
  GET_EVENT_COMMENT_SUCCESS,
  GET_EVENT_CLUB_SUCCESS,
  POST_CREATE_EVENT_SUCCESS,
  POST_CREATE_EVENT_INTEREST_SUCCESS,
  POST_CREATE_EVENT_COMMENT_SUCCESS,
  DELETE_EVENT_COMMENT_SUCCESS,
  PATCH_DELETE_EVENT_SUCCESS,
  PATCH_DELETE_USER_EVENT_INTEREST_SUCCESS,
  PATCH_DELETE_USER_EVENT_INTERESTED_SUCCESS,
  PATCH_UPDATE_MY_USER_EVENT_SUCCESS,
  MERGE_DATA_EVENT_SUCCESS,
  UPDATE_STATE_EVENT_HOME,
  SET_STATE_ENTITIES_TYPE_GUEST,
  GET_EVENT_REPLY_SUCCESS,
  GET_EVENT_REPLY_SHOW_MORE_SHOW_LESS,
  GET_EVENT_POPULAR_COUNT_SUCCESS,
  GET_ACTIVE_USER_POPULAR_COUNT_SUCCESS,
  GET_CLUB_COUNT_SUCCESS,
  POST_CREATE_COMMENT_LIKE_SUCCESS,
  DELETE_COMMENT_LIKE_SUCCESS,
  REQUEST_GET_DETAIL_CLUB_EVENT,
  GET_DETAIL_CLUB_EVENT_FAIL,
  GET_DETAIL_CLUB_EVENT_SUCCESS,
  GET_PHOTO_DETAIL_CLUB_SUCCESS,
  CLOSE_CLUB_DETAIL,
  DELETE_PARENT_OWNED_COMMENT,
  DELETE_THREAD_MESSAGE,
  GET_PUBLIC_LIVE_STREAMS_REQUEST,
  GET_PUBLIC_LIVE_STREAMS_FAILURE,
  GET_PUBLIC_LIVE_STREAMS_SUCCESS,
  GET_MORE_PUBLIC_LIVE_STREAMS_SUCCESS,
  GET_LIST_VIEWERS_STATUS_SUCCESS,
  UPDATE_USER_STATUS_LIVE_SUCCESS,
  CHANGE_PUBLIC_LIVE_STREAMS_FILTERED,
  UPDATE_UNREAD_MESSAGE_ALL_SUCCESS,
  UPDATE_ORIENTATION_SCREEN,
  UPDATE_PREVIOUS_SCREEN,
  UPDATE_STATUS_SHOULD_SELECT_CONVERSATION_SCREEN,
  UPDATE_USERID_SHOULD_SELECT_ON_MESSENGER_SCREEN,
  RESET_USERID_SHOULD_SELECT_ON_MESSENGER_SCREEN,
  ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_REQUEST,
  ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_FAILURE,
  ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER_SUCCESS,
  GET_FOLDERS_REQUEST,
  GET_FOLDERS_FAILURE,
  GET_FOLDERS_SUCCESS,
  CREATE_FOLDER_REQUEST,
  CREATE_FOLDER_FAILURE,
  CREATE_FOLDER_SUCCESS,
  UPDATE_FOLDER_REQUEST,
  UPDATE_FOLDER_FAILURE,
  UPDATE_FOLDER_SUCCESS,
  DELETE_FOLDER_REQUEST,
  DELETE_FOLDER_FAILURE,
  DELETE_FOLDER_SUCCESS,
  UPDATE_CONVERSATION_GROUP_COVER_URL,
  UPDATE_CONVERSATION_USER_BOOST_EXPIRY_TIME,
  UPDATE_CONVERSATION_BUDDY_BOOST_EXPIRY_TIME,
  UPDATE_CONVERSATION_SEARCH,
  UPDATE_STATE_CONVERSATION_SEARCH,
  ADD_CONVERSATION_TO_FOLDER_REQUEST,
  ADD_CONVERSATION_TO_FOLDER_FAILURE,
  ADD_CONVERSATION_TO_FOLDER_SUCCESS,
  LOADING_PUBLIC_GROUP_CHAT_MEMBER,
  ADD_JOINING_MEMBER_PUBLIC_GROUP_CHAT,
  REMOVE_JOINING_MEMBER_PUBLIC_GROUP_CHAT,
  CLEAR_JOINING_MEMBER_PUBLIC_GROUP_CHAT,
  UPDATE_IS_STREAMING,
  REMOVE_CONVERSATION_FROM_FOLDER_REQUEST,
  REMOVE_CONVERSATION_FROM_FOLDER_FAILURE,
  REMOVE_CONVERSATION_FROM_FOLDER_SUCCESS,
  SELECT_FOLDER_SUCCESS,
  GET_NOTIFICATION_COUNT_FOR_NEW_FEED_SUCCESS,
  GET_NOTIFICATION_COUNT_FOR_PROSPECT,
  UPDATE_STATE_NOTIFICATION_COUNT,
  UPDATE_COUNT_FOR_NEW_VIEWS,
  UPDATE_COUNT_FOR_NEW_MATCHES,
  UPDATE_COUNT_FOR_NEW_FAVOURITES,
  UPDATE_COUNT_FOR_NEW_LIKES,
  GET_GALLERIES_REQUEST,
  GET_USER_PHOTO_REQUEST,
  GET_GALLERIES_SUCCESS,
  GET_USER_PHOTO_SUCCESS,
  GET_USER_PROFILE_PHOTO_SUCCESS,
  SET_LOADED_ALL_GENERAL_DETAILS_SUCCESS,
  GET_PROPERTY_SUCCESS,
  GET_PROPERTY_PROFILE_BUILDER,
  GET_INTEREST_PROPERTY_SUCCESS,
  PATCH_UPDATE_USER_PHOTO_SUCCESS,
  UPLOAD_PHOTO_SUCCESS,
  RESET_USER_PHOTO,
  RESET_STATUS_LOADED_PHOTO_AND_DATA,
  POST_VERIFICATION_SUCCESS,
  DELETE_VALIDATION_SUCCESS,
  APPROVE_VALIDATION_SUCCESS,
  UPDATE_EDIT_PROFILE_STATE,
  UPDATE_STATE_EDIT_PROFILE_WITH_KEY,
  UPDATE_MENU_SELECTED,
  UPDATE_VALIDATION_STATE,
  GET_VALIDATION_SUCCESS,
  UPDATE_BLOCK_LIST_STATE,
  GET_BLOCK_LIST_SUCCESS,
  DELETE_BLOCK_SUCCESS,
  GET_ACTIVE_USERS_REQUEST,
  GET_ACTIVE_USERS_BY_FILTER_REQUEST,
  TOGGLE_HAS_FILTERED_USERS_ACTIVE_STATUS,
  GET_ACTIVE_USERS_SUCCESS,
  GET_ACTIVE_USERS_FILTERED_SUCCESS,
  GET_ACTIVE_USERS_FAILED,
  GET_ACTIVE_USERS_FILTERED_FAILED,
  UPDATE_HIDDEN_LIST_STATE,
  GET_HIDDEN_LIST_SUCCESS,
  DELETE_HIDDEN_LIST_SUCCESS,
  DELETE_ALL_PROFILE_HIDDEN_SUCCESS,
  UPDATE_PRIVATE_ALBUM_ACCESS_STATE,
  GET_PRIVATE_ALBUM_ACCESS_SUCCESS,
  UPDATE_PRIVATE_ALBUM_ACCESS_SUCCESS,
  UPDATE_PRIVATE_ALBUM_STATUS_SUCCESS,
  CREATE_USER_TOOLTIP_SUCCESS,
  INCREASE_TOOLTIP_VIEW_COUNT_FACE_ID,
  UPDATE_STATE_PAYMENT_GATEWAY,
  GET_PAYMENT_SUCCESS,
  UPDATE_DIAMONDS,
  UPDATE_STATE_DATE_FINDER_SUCCESS,
  GET_LIST_DATE_FINDER_SUCCESS,
  POST_FILTER_DATE_FINDER_SUCCESS,
  POST_CREATE_DATE_FINDER_SUCCESS,
  GET_MY_DATE_FINDER_SUCCESS,
  GET_DETAIL_DATE_FINDER_SUCCESS,
  DELETE_MY_DATE_FINDER_SUCCESS,
  GET_DATE_FINDER_INTERESTS_SUCCESS,
  PATCH_DATE_FINDER_INTEREST_SUCCESS,
  PATCH_DATE_FINDER_UN_INTEREST_SUCCESS,
  UPDATE_MEMBER_TYPE_STATE_DATE_FINDER,
  DATE_FINDER_SEARCH,
  ADD_DATE_FINDER_DESCRIPTIONS_SUCCESS,
  ADD_DATE_FINDER_MEETING_TYPES_SUCCESS,
  DATE_FINDER_SUGGESTED,
  GET_MORE_DATE_FINDER_SUCCESS,
  DATE_FINDER_BLOCK_USER_SUCCESS,
  HANDLE_DATE_FINDER_MEETING_TYPES,
  UPDATE_MEMBER_TYPE_STATE_ADD_DATE_FINDER,
  UPDATE_QUICK_SELECT_DATE_DATE_FINDER,
  UPDATE_QUICK_SELECT_LOCATION_DATE_FINDER,
  TOGGLE_ADD_DATE_MODAL,
  UPDATE_HAS_CHANGE_FILTERS_STATUS,
  UPDATE_SEARCH_DATE_FINDER_STATUS,
  EDIT_MY_DATE_SUCCESS,
  UPDATE_STATE_TRAVEL_PLAN_SUCCESS,
  POST_CREATE_TRAVEL_PLAN_SUCCESS,
  PATCH_UPDATE_TRAVEL_PLAN_SUCCESS,
  GET_MY_TRAVEL_PLAN_SUCCESS,
  GET_MY_TRAVEL_PLAN_FAILED,
  DELETE_MY_TRAVEL_PLAN_SUCCESS,
  GET_DETAIL_TRAVEL_PLAN_SUCCESS,
  GET_USER_TRAVEL_SUCCESS,
  UPDATE_MEMBER_TYPE_STATE_TRAVEL_PLAN,
  SEARCH_TRAVEL_SUCCESS,
  TOGGLE_SINGLE_DATE_MODAL,
  TOGGLE_SINGLE_DATE_CUSTOME_MODAL,
  SET_QUICK_DATE_SUCCESS,
  TOGGLE_MY_DATE_MODAL,
  TOGGLE_GREAT_IDEAL,
  GET_TRAVEL_PLAN_EVENTS_SUCCESS,
  SHOW_ADD_EDIT_TRAVEL_PLAN_MODAL,
  HIDE_ADD_EDIT_TRAVEL_PLAN_MODAL,
  TOGGLE_MY_TRAVEL_PLAN_MODAL,
  UPDATE_TRAVEL_PLAN_NEAR_YOU,
  CREATE_EVENT_INTEREST_TRAVEL,
  DELETE_INTEREST_TRAVEL,
  UPDATE_LIKE_OR_FAVORITE_MUTAL,
  UPDATE_STATE_FORUM_STATE,
  TOGGLE_REGIONAL_FORUM_LOCATION,
  GET_BOARD_DATA_SUCCESS,
  GET_BOARD_DATA_SUMMARY_SUCCESS,
  GET_TRENDING_FORUM_SUCCESS,
  GET_NEWEST_FORUM_SUCCESS,
  UPDATE_TRENDING_TOPIC_STATE,
  UPDATE_NEWEST_TOPIC_STATE,
  GET_FOLLOWING_TOPIC_SUCCESS,
  GET_FOLLOWING_TOPIC_DESKTOP_SUCCESS,
  GET_MY_TOPIC_SUCCESS,
  GET_MY_TOPIC_DESKTOP_SUCCESS,
  UPDATE_FOLLOWING_TOPIC_STATE,
  UPDATE_MY_TOPIC_STATE,
  GET_SUB_FORUM_SUCCESS,
  GET_FORUM_TOPIC_SUCCESS,
  GET_SUB_FORUM_TOPIC_SUCCESS,
  GET_SUB_TOPIC_MORE_MESSAGE_SUCCESS,
  POST_CREATE_FORUM_TOPIC_LIKE_SUCCESS,
  POST_CREATE_FORUM_TOPIC_UNLIKE_SUCCESS,
  UPDATE_SUB_TOPIC_STATE,
  UPDATE_FORUM_TOPIC_STATE,
  UPDATE_SEARCH_RESULT_BY_TAGS_STATE,
  GET_SEARCH_RESULT_BY_TAGS_SUCCESS,
  GET_SEARCH_FORUM_BY_TAGS_SUCCESS,
  POST_CREATE_TOPIC_FOLLOWING_SUCCESS,
  POST_CREATE_TOPIC_UN_FOLLOW_SUCCESS,
  DELETE_TOPIC,
  POST_CREATE_TOPIC_MESSAGE_LIKE_SUCCESS,
  POST_CREATE_TOPIC_MESSAGE_UNLIKE_SUCCESS,
  GET_TOPIC_MESSAGE_COMMENT_SUCCESS,
  POST_CREATE_TOPIC_MESSAGE_REPLY_SUCCESS,
  POST_CREATE_TOPIC_MESSAGE_SUCCESS,
  DELETE_TOPIC_MESSAGE_SUCCESS,
  UPDATE_COMMUNITY_STORY_ID_SELECTED,
  UPDATE_COMMUNITY_STATE,
  GET_ARTICLE_CATEGORIES_COUNT_SUMMARY,
  GET_QUESTION_AND_ANSWER_CATEGORIES_COUNT_SUMMARY,
  GET_STORY_CATEGORIES_COUNT_SUMMARY,
  GET_ARTICLES,
  GET_QUESTION_AND_ANSWER,
  GET_STORIES,
  GET_MY_STORIES,
  DELETE_STORIES,
  GET_OTG_LIST,
  GET_TESTIMONIAL,
  GET_COMMUNITY_DETAILS,
  GET_COMMUNITY_COMMENTS,
  UPDATE_LOADING_STATE,
  DELETE_OTG_GALLERY_LIKE,
  UPDATE_COMMUNITY_DETAIL_COMMENT_FAILED,
  GET_REPLY_SUCCESS,
  GET_OTG_PHOTO_REPLY_SUCCESS,
  POST_CREATE_LIKE_COMMUNITY_SUCCESS,
  POST_CREATE_UN_LIKE_COMMUNITY_SUCCESS,
  GET_REPLY_SHOW_MORE_SHOW_LESS,
  POST_CREATE_COMMUNITY_COMMENT_LIKE_SUCCESS,
  POST_CREATE_OTG_PHOTO_COMMENT_LIKE_SUCCESS,
  DELETE_COMMUNITY_COMMENT_LIKE_SUCCESS,
  DELETE_OTG_PHOTO_COMMENT_LIKE_SUCCESS,
  GET_OTG_PHOTOS,
  GET_OTG_PHOTOS_COMMENTS,
  GET_OTG_PHOTOS_LIKE,
  POST_COMMENT_OTG_PHOTO_SUCCESS,
  DELETE_OTG_PHOTO_COMMENT_SUCCESS,
  POST_COMMENT_COMMUNITY_SUCCESS,
  LOADING_COMMUNITY_DETAILS,
  DELETE_COMMUNITY_COMMENT_SUCCESS,
  LOADING_OTG_PHOTO_DETAILS,
  TOPIC_LIKE_USER,
  GET_COMMUNITY_LIKE_USER_SUCCESS,
  GET_COMMUNITY_LIKE_USER_FAILED,
  UPDATE_SHOW_SUPPORT_TICKET,
  APP_IN_BACKGROUND_TIME,
  UPDATE_TOPIC_LIKE_USER,
  GET_STORY_AUTH_DETAIL,
  GET_SUPPORT_TICKET_NEW_COUNT,
  GET_LIST_SUPPORT_TICKET_REQUEST,
  GET_LIST_SUPPORT_TICKET_SUCCESS,
  GET_LIST_SUPPORT_TICKET_FAILED,
  GET_CATEGORY_CONTACT_SUCCESS,
  GET_DETAIL_SUPPORT_TICKET_REQUEST,
  GET_DETAIL_SUPPORT_TICKET_SUCCESS,
  GET_DETAIL_SUPPORT_TICKET_FAILED,
  RESET_DETAIL_SUPPORT_TICKET_SUCCESS,
  UPDATE_LAST_MESSAGE_SELECTED_SUPPORT_TICKET_SUCCESS,
  SHOW_LIST_SUPPORT_TICKET_MODAL,
  HIDE_LIST_SUPPORT_TICKET_MODAL,
  UPDATE_REF_TICKET_DETAIL,
  UPDATE_VIEWING_USER_ID,
  MODAL_AUTHENTICATE,
  SELECT_PREVIEW_PHOTO,
  GET_PROFILE_ACTIVITY_SUCCESS,
  GET_PROFILE_GROUPS_SUCCESS,
  TOGGLE_RECENTLY_SENT_PHOTO,
  TOGGLE_SET_MESSAGE_IMAGE_DURATION_MODAL,
  SET_TIME_DURATION_SELECTION_VALUE,
  GET_USER_SHARED_PHOTOS_SUCCESS,
  ADD_USER_MEDIA_SUCCESS,
  PATCH_USER_SHARED_PHOTOS_SUCCESS,
  PATCH_USER_SHARED_VIDEOS_SUCCESS,
  ADD_PRODUCT_TO_STORE_REQUEST,
  ADD_PRODUCT_TO_STORE_FAILED,
  ADD_PRODUCT_TO_STORE_SUCCESS,
  GET_USER_CURRENT_STORE_ORDER_REQUEST,
  GET_USER_CURRENT_STORE_ORDER_FAILED,
  GET_USER_CURRENT_STORE_ORDER_SUCCESS,
  TOGGLE_CART_VIEW_SUCCESS,
  SELECT_PRODUCT_ITEM_SUCCESS,
  GET_STORE_PRODUCT_IMAGE_REQUEST,
  GET_STORE_PRODUCT_IMAGE_FAILED,
  GET_STORE_PRODUCT_IMAGE_SUCCESS,
  GET_STORE_PRODUCTS_REQUEST,
  GET_STORE_PRODUCTS_FAILED,
  GET_STORE_PRODUCTS_SUCCESS,
  UPDATE_STATE_RHP_STORE,
  UPDATE_STATE_RHP_STORE_WITH_KEY,
  UPDATE_STORE_PRODUCT_CATEGORY,
  GET_USER_STORE_CREDITS_SUCCESS,
  GET_USER_ORDER_DETAIL_SUCCESS,
  GET_CLUB_EVT_SUCCESS,
  GET_CLUB_PAST_EVT_SUCCESS,
  DELETE_CLUB_COMMENT_SUCCESS,
  POST_CREATE_UPDATE_VOTE_SUCCESS,
  UPDATE_STATE_EVENT_DETAIL,
  UPDATE_USER_PHOTO_GROUP_CHAT,
  END_GROUP_CHAT_SUCCESS,
  UPDATE_STATE_GROUP_CHAT,
  DELETE_EVENT_INTEREST_BY_OWNER_SUCCESS,
  MERGE_FILTER_INTERESTED,
  UPDATE_METRICS_STATUS,
  UPDATE_WINDOW_DIMENSIONS,
  TOGGLE_OPTION_DATE_FINDER_EVENT,
  UPDATE_CHAT_SYSTEM_DOWN_MODAL_STATUS,
  UPDATE_MEMBER_TYPE_STATE_VALIDATED,
  UPDATE_STATE_VALIDATED_SUCCESS,
  UPDATE_RECENTLY_VALIDATION_STATUS,
  GET_RECENTLY_VALIDATION_DATA_SUCCESS,
  GET_SHARED_MEDIA_REQUEST,
  GET_SHARED_MEDIA_SUCCESS,
  GET_SHARED_MEDIA_FAILED,
  DELETE_SHARED_MEDIA_SUCCESS,
  LOADING_GROUP_CHAT_CAN_BE_INVITE,
  GET_GROUP_CHAT_CAN_BE_INVITE_SUCCESS,
  ADD_GROUP_SHOULD_SEND_JOIN_MESSAGE,
  REMOVE_GROUP_SHOULD_SEND_JOIN_MESSAGE,
  ADD_ROOMJID_SHOULD_SEND_JOIN_MESSAGE,
  ADD_ROOMJID_SENDING_JOIN_MESSAGE,
  TOGGLE_CLOSE_LIVE_STREAM,
  REMOVE_ROOMJID_SHOULD_SEND_JOIN_MESSAGE,
  UPDATE_GROUP_CHAT_MESSAGE_STATUS,
  UPDATE_FEATURE_ROOMS_DATA,
  UPDATE_FEATURE_ROOM_DATA,
  UPDATE_SELECTED_GROUP_DATA,
  UPDATE_PROFILE_BOOST_PRODUCTS,
  UPDATE_CONVERSATION_BOOST_PRODUCTS,
  UPDATE_GENDER_TYPE_CHANGE_PRODUCTS,
  UPDATE_LIKE_PRODUCTS,
  UPDATE_FAV_PRODUCTS,
  UPDATE_USER_REMAINING_INVITES_CREDIT,
  UPDATE_INVITES_CREDIT_PRODUCTS,
  GET_LOCATION,
  UPDATE_DATA_SPOTLIGHT_SUCCESS,
  UPDATE_OPTIONS_PROFILE_SUMMARY_SUCCESS,
  GET_GROUP_POPULAR_SEARCH_SUCCESS,
  GET_GROUP_DESKTOP_POPULAR_SEARCH_SUCCESS,
  GET_GROUP_DETAIL_SUCCESS,
  GET_GROUP_VOTE_COMMENTS_SUCCESS,
  GET_GROUP_JOINED_USERS_SUCCESS,
  GET_GROUP_EVENTS_SUCCESS,
  GET_GROUP_PHOTOS_SUCCESS,
  GET_GROUP_VIDEOS_SUCCESS,
  GET_GROUP_ALBUMS_SUCCESS,
  GET_GROUP_ACTIVITY_SUCCESS,
  GET_GROUP_ALERT_SUCCESS,
  REMOVE_GROUP_SUCCESS,
  CREATE_GROUP_SUCCESS,
  UPDATE_GROUP_SUCCESS,
  UPDATE_BANNER_GROUP_SUCCESS,
  TOGGLE_REMINDER_FEATURE_CHAT_ROOM_SUCCESS,
  UPDATE_GROUP_EVENT_SUCCESS,
  GET_MY_GROUP_SUCCESS,
  GET_JOINED_GROUP_SUCCESS,
  MERGE_DATA_GROUP,
  MERGE_DATA_EVENT,
  UPDATE_DATA_GROUP,
  BLOCK_A_GROUP_SUCCESS,
  JOIN_A_GROUP_SUCCESS,
  LEAVE_A_GROUP_SUCCESS,
  POST_UPDATE_MEDIA_COMMENT_SUCCESS,
  UPDATE_MEDIA_LIKE_SUCCESS,
  POST_CREATE_POST_COMMENT_SUCCESS,
  UPDATE_POST_LIKE_SUCCESS,
  GET_POST_COMMENT_SUCCESS,
  GET_POST_LIKE_USERS_SUCCESS,
  GET_POST_DETAIL_SUCCESS,
  POST_DELETE_POST_COMMENT_SUCCESS,
  GET_MORE_REPLIES_SUCCESS,
  GET_MORE_ALBUM_REPLIES_SUCCESS,
  UPDATE_POST_COMMENT_LIKE_SUCCESS,
  UPDATE_ALBUM_COMMENT_LIKE_SUCCESS,
  DELETE_POST_SUCCESS,
  INIT_MEDIA_UPLOADING_STATE,
  UPDATE_MEDIA_UPLOADING_STATE,
  DELETE_ALBUM_SUCCESS,
  GET_GROUP_CHATS_SUCCESS,
  GET_ALBUM_DETAIL_SUCCESS,
  RESET_POST_DETAIL_DATA_SUCCESS,
  UPDATE_ALBUM_DETAIL_SUCCESS,
  UPDATE_POST_DETAIL_SUCCESS,
  GET_CLUB_LIST_CAN_BE_INVITED_SUCCESS,
  GET_JOIN_USER_REQUEST_SUCCESS,
  GET_RECOMMENDED_GROUP_SUCCESS,
  GET_RECOMMENDED_GROUP_REQUEST,
  GET_RECOMMENDED_GROUP_FAILED,
  UPDATE_GROUP_MEMBER_SUCCESS,
  PATCH_CLUB_USER_BAN_POSTING_SUCCESS,
  PATCH_CLUB_USER_MEMBER_LEVEL_SUCCESS,
  GET_ALBUM_COMMENT_SUCCESS,
  DELETE_ALBUM_COMMENT_SUCCESS,
  DELETE_CLUB_MEDIA_SUCCESS,
  MERGE_DATA_GROUP_NOTIFICATION,
  GET_GROUP_ACTIVITIES_NOTIFICATION_SUCCESS,
  GET_GROUP_JOIN_REQUEST_NOTIFICATION_SUCCESS,
  GET_GROUP_ALERTS_SUCCESS,
  GET_GROUP_SUGGESTED_USERS_SUCCESS,
  GET_EVENT_SUGGESTED_USERS_SUCCESS,
  GET_GROUP_SUGGESTED_USERS_REQUEST,
  GET_EVENT_SUGGESTED_USERS_REQUEST,
  GET_ALL_GROUP_ACTIVITY_SUCCESS,
  RESET_GROUP_ACTIVITY_SUCCESS,
  GET_ALL_GROUP_ACTIVITY_REQUEST,
  UPDATE_GROUP_SUGGESTED_USER_FILTER,
  RESET_GROUP_SUGGESTED_USER_FILTER,
  UPDATE_EVENT_SUGGESTED_USER_FILTER,
  RESET_EVENT_SUGGESTED_USER_FILTER,
  GET_INVITES_GROUP_RECEIVED_REQUEST,
  GET_INVITES_GROUP_RECEIVED_FAILED,
  GET_INVITES_GROUP_RECEIVED_SUCCESS,
  DELETE_INVITES_GROUP_RECEIVED_SUCCESS,
  UPDATE_GROUP_ACTIVITY_LOADING,
  RESET_GROUP_INVITE_SUCCESS,
  GET_USER_CLUB_NEW_USERS,
  GET_USER_INVITE_SUCCESS,
  TOGGLE_EVENT_INTEREST_SUCCESS,
  TOGGLE_EVENT_INTEREST_SUCCESS_GROUP_ACTIVITY,
  GET_SUGGESTED_GROUP_SUCCESS,
  INIT_MEDIA_UPLOADING_STATE_REPORT,
  RESET_MEDIA_UPLOADING_STATE_REPORT,
  UPDATE_MEDIA_UPLOADING_STATE_REPORT,
  UPGRADE_PERMISSION_GROUP_DETAIL,
} as const;

// Export union type of all action type literals
export type ActionType = (typeof ACTION_TYPES)[keyof typeof ACTION_TYPES];
